import ErrorOutlineSharpIcon from '@mui/icons-material/ErrorOutlineSharp'
import { Box, Card, CircularProgress, Dialog, DialogContent, DialogTitle, Fade, FormControl, Button as MButton, Menu, MenuItem, Modal, Tab, Tabs } from '@mui/material'
import Grid from "@mui/material/Grid"
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useReducer, useRef, useState } from 'react'
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import toast from 'react-hot-toast'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { ReactComponent as GraphIcon } from "../../assets/icons/graph-icon.svg"
import { ReactComponent as AngleDownIcon, ReactComponent as DropDownIcon } from '../../assets/icons/icon-angle-down.svg'
import { ReactComponent as SettingIcon } from "../../assets/icons/icon-feather-settings-plain.svg"
import { ReactComponent as CloseIcon } from "../../assets/icons/icon_close.svg"
import { ReactComponent as TableIcon } from "../../assets/icons/table-icon.svg"
import MaterialMenu from '../../components/MaterialMenu'
import { CalculatedFieldsV2 } from '../../components/_report/cards'
import FilterDateRangeView from '../../components/_report/cards/FilterDateRangeView'
import FilterGreaterLessValue from '../../components/_report/cards/FilterGreaterLessValue'
import FilterMultipleSelectValue from '../../components/_report/cards/FilterMultipleSelectValue'
import FilterSelectValue from '../../components/_report/cards/FilterSelectValue'
import FilterSingleDate from '../../components/_report/cards/FilterSingleDate'
import FormatControl from '../../components/_reportFilterForm/FormatControl'
import Limit from '../../components/common/Limit'
import Button from '../../components/controls/Button'
import { addVersion } from '../../config/services/config'
import { addMeasures, getMeasureById, getMeasuresList } from '../../config/services/measures'
import { addReport, deleteReport, getReportById, updateReportById, validateUserReport } from '../../config/services/reports'
import { validateUserRole } from '../../config/services/role'
import { LimitAllowedIn } from '../../constants/chartType'
import { GREATER_LESS_THAN_FILTER, NUMBER_FILTER_TYPE } from '../../constants/filterType'
import { MeasureListContextProvider } from '../../contexts/MeasureListContext'
import Column from "../../helper/Pivot/Column"
import { savePDF } from "../../modifiedlibraries/pdfExport/react-to-pdf-converter"
import ReportFilter from '../../pages/ReportFilter'
import ReportGraph from '../../pages/ReportGraph'
import ReportSettings from '../../pages/ReportSettings'
import ReportVisualizeSettings from '../../pages/ReportVisualizeSettings'
import { containsSpecialCharacter, generateCustomDateRange, isMobileView } from '../../utils/Reusables'
import GraphTypesConfig from '../graph/GraphTypesConfig'
import StaticGraphTypesConfig from '../graph/StaticGraphTypesConfig'
import DeleteReportDialog from './DeleteReportDialog'
import EmptyChart from './EmptyChart'
import ReportHeader from './ReportHeader'
import ReportSaveAsDialog from './ReportSaveAsDialog'
import ReportSettingsSidebar from './ReportSettingsSidebar'
import ReportSideBar from './ReportSideBar'

import { NumberChartDescriptionLength, NumberChartTitleLength } from "../../constants/stringParams"
import { handleStringLength } from "../../utils/multiLangDashboardV2Data"

import Slider from "react-slick"
import { CarouselNextArrow, CarouselPrevArrow } from "./../../utils/Reusables"
import { ReportDetailsContextProvider, ComparisonChartDetailsContextProvider, QuickFilterContextProvider } from './ReportDetailsContext'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import 'swiper/swiper.min.css'
import 'swiper/modules/navigation/navigation.min.css';

// ----------------------------------------------------------------------
let source;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
})

const MainStyleWrapper = styled('div')(({ theme }) => ({
  height: '100%',
  width: '100%'
}))

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: 'calc(100% - 46px)',
  paddingTop: '0.5rem',
  paddingBottom: '0',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('lg')]: {
    paddingTop: '0.5rem',
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    paddingBottom: '1rem',
  },
  [theme.breakpoints.down('sm')]: {
    paddingTop: '0rem',
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    paddingBottom: '3rem',
  },
}))

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "10%",
    width: "100"
  },
  graphFiltergrid: {
    [theme.breakpoints.down('sm')]: {
      marginTop: '0rem',
      '& > .MuiGrid-item': {
        paddingTop: 0,
      },
    },
  },
  inputLabel: {
    minHeight: '21px',
  }
}))

export default function ReportLayout() {
  const UrlParams = useParams()
  const queryParams = useLocation().search;
  const classes = useStyles();
  const [deleteObj, setDeleteObj] = useState({})
  const [deletePopup, setDeletePopup] = useState(false)
  const [open, setOpen] = useState(false)
  const [selectedSidebarMenu, setSelectedSidebarMenu] = useState('Visualize')
  const [children, setChildren] = useState(<></>)
  const [reportDetails, setReportDetails] = useState(null)
  const [saveLoader, setSaveLoader] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState({})
  const [openPopupFilter, setOpenPopupFilter] = useState(false);
  const [recordForEdit, setRecordForEdit] = useState(null)
  const [pivotConfig, setPivotConfig] = useState({
    xAxis: { id: "xAxis", list: [], type: "dimensions", label: 'X Axis' },
    value: { id: "value", list: [{ id: "1", text: "measures", type: "measures" },], label: 'Value' },
    lines: { id: "Lines", list: [], label: 'Lines' },
    group: { id: "group", list: [], label: 'Group' }
  })
  const [openPopup, setOpenPopup] = useState(false)
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const navigate = useNavigate()
  const [orderAnchorEl, setOrderAnchorEl] = useState({})
  const [orderplaceholderProps, setorderPlaceholderProps] = useState({});
  let [measureTitle, setMeasureTitle] = useState({})
  let [dimensionTitle, setDimensionTitle] = useState({})
  const [dateFieldFormat, setDateFieldFormat] = useState({})
  const [expandedSettings, setExpandedSettings] = useState(null);
  const [openCalculatedFields, setOpenCalculatedFields] = useState(false)
  const [fieldWellsWidth, setFieldWellsWidth] = useState('200px')
  const [fieldWellsLeftPosition, setFieldWellsLeftPosition] = useState(0)
  const [fieldWellsRightPosition, setFieldWellsRightPosition] = useState(0)
  const [saveAsPopup, setSaveAsPopup] = useState(false)
  const [deleteReportPopup, setDeleteReportPopup] = useState(false)
  const reportContainerRef = useRef(null);
  const chartContainerRef = useRef(null);
  const fieldWellsRef = useRef();
  const [measureList, setMeasureList] = useState([])
  const [restrictOption, setRestrictOption] = useState(false)
  const [commonFields, setCommonFields] = useState([])
  const [hyperlinkCount, setHyperlinkCount] = useState(1);
  const [selectedReportTab, setSelectedReportTab] = useState(0);
  const [currentUserType, setCurrentUserType] = useState({})
  const [exportProcessDialog, setExportProcessDialog] = useState(false)
  const IsExportUrl = new URLSearchParams(queryParams).get('export');
  const exportType = new URLSearchParams(queryParams).get('type');

  const [reportGridBgColor, setReportGridBgColor] = useState(null);
  const [reportHasBgColor, setReportHasBgColor] = useState(null);
  const [reportBgColor, setReportBgColor] = useState(null);
  const [reportBorderColor, setReportBorderColor] = useState(null);
  const [reportHasBorder, setReportHasBorder] = useState(null);
  const [reportCarouselElevationColor, setReportCarouselElevationColor] = useState(null);
  const [reportCarouselCardElevationColor, setReportCarouselCardElevationColor] = useState(null);
  //const [reportIsCarouselCardTitle, setReportIsCarouselCardTitle] = useState(null);
  const [reportCarouselCardSpacing, setReportCarouselCardSpacing] = useState('0');
  const [reportHasCarouselElevation, setReportHasCarouselElevation] = useState(null);
  const [reportHasCarouselCardElevation, setReportHasCarouselCardElevation] = useState(null);
  const [chartContainerWidth, setChartContainerWidth] = useState(0);

  useEffect(() => {
    window.addEventListener('resize', chartResize);
    if (chartContainerRef?.current) {
      setChartContainerWidth(chartContainerRef?.current?.clientWidth);
    }
  }, [chartContainerRef?.current, open, reportHasBorder, reportHasBgColor, reportHasCarouselElevation]);

  const chartResize = () => {
    if (chartContainerRef && chartContainerRef?.current) {
      setChartContainerWidth(chartContainerRef?.current?.clientWidth);
    }
  }


  const exportPDFWithMethod = (mode) => {
    let element = reportContainerRef.current || document.body;

    if (mode === "report") {
      savePDF(element, {
        paperSize: "auto",
        landscape: true,
        fileName: `Report for ${new Date().getFullYear()}`
      }, () => {
        if (IsExportUrl === "true" || IsExportUrl === true) {
          window.close();
          setExportProcessDialog(false)
        }
      });
    }
    else {
      setTimeout(() => {
        savePDF(element, {
          paperSize: "auto",
          landscape: true,
          fileName: `Report for ${new Date().getFullYear()}`
        }, () => {
          if (IsExportUrl === "true" || IsExportUrl === true) {
            window.close();
            setExportProcessDialog(false)
          }
        });

      }, [5000])
    }
  };


  const handleOrderClose = () => {
    setOrderAnchorEl({});
  };

  const onOrderDragEnd = result => {
    if (!result.destination) {
      return;
    }
    setorderPlaceholderProps({})
    if (result?.destination?.index >= reportDetails?.reportDetails?.orderBy.length) {
      var k = result?.destination?.index - reportDetails?.reportDetails?.orderBy.length + 1;
      while (k--) {
        reportDetails?.reportDetails?.orderBy.push(undefined);
      }
    }
    reportDetails?.reportDetails?.orderBy.splice(result?.destination?.index, 0, reportDetails?.reportDetails?.orderBy.splice(result?.source?.index, 1)[0]);
    setReportDetails({ reportDetails: reportDetails?.reportDetails })
  };

  const getOrderItemStyle = (isDragging, draggableStyle) => {
    draggableStyle.height = 50
    return {
      userSelect: "none",
      margin: `0 0 8px 0`,
      display: `flex`,
      cursor: 'pointer',
      alignItems: 'center',
      justifyContent: 'space-around',
      position: 'relative',
      ...draggableStyle
    }
  }

  const onOrderDragUpdate = update => {
    if (!update.destination) {
      return;
    }
    const queryAttr = "data-rbd-drag-handle-draggable-id";
    const draggableId = update.draggableId;
    const destinationIndex = update.destination.index;
    const domQuery = `[${queryAttr}='${draggableId}']`;
    const draggedDOM = document.querySelector(domQuery);
    if (!draggedDOM) {
      return;
    }
    const { clientHeight, clientWidth } = draggedDOM;

    const clientY = parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingTop) + [...draggedDOM.parentNode.children]
      .slice(0, destinationIndex)
      .reduce((total, curr) => {
        const style = curr.currentStyle || window.getComputedStyle(curr);
        const marginBottom = parseFloat(style.marginBottom);
        return total + curr.clientHeight + marginBottom;
      }, 0);
    setorderPlaceholderProps({
      clientHeight,
      clientWidth,
      clientY,
      clientX: parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingLeft)
    });
  };

  const handleDimensionMeasureMapping = async (measure) => {
    const dragged = reportDetails?.reportDetails['dimensions'].filter(ele => ele?.fieldName === measure?.text);
    let params = { measureId: dragged[0]?.fieldId }
    const measureDetails = await getMeasureById(params)
    createCustomField(measureDetails?.result, measure)
  }

  const handleMeasureDimensionMapping = async (measure) => {
    let pivotMeasure;
    if ((measure?.text).includes('Sum')) {
      pivotMeasure = (measure?.text).split('Sum')[0]
    }
    if ((measure?.text).includes('Count')) {
      pivotMeasure = (measure?.text).split('Count')[0]
    }
    if (pivotMeasure) {
      const exist = reportDetails?.reportDetails?.dimensions.find(ele => ele?.fieldName === pivotMeasure)
      if (!exist) {

        let params = { dataSetId: reportDetails?.reportDetails?.dataSetId?._id, search: pivotMeasure.split('.')[1] }
        const res = await getMeasuresList(params);
        if (res?.result?.length) {
          let newField = {
            fieldName: pivotMeasure,
            fieldId: res.result[0]._id
          }
          reportDetails?.reportDetails?.dimensions.push(newField)
          reportDetails.reportDetails.measures = reportDetails?.reportDetails?.measures.filter(item => item.fieldName !== measure?.text)
          reportDetails.reportDetails.pivotConfig['value'].list = reportDetails?.reportDetails?.pivotConfig['value']?.list.filter(item => item?.text !== measure?.text)
          reportDetails?.reportDetails?.pivotConfig['xAxis']?.list.push({
            id: res.result[0]._id,
            text: pivotMeasure,
            type: "dimensions"
          })
          reportDetails.reportDetails.orderBy = reportDetails?.reportDetails?.orderBy.filter(ele => ele?.content?.key !== measure?.text)
          const order = reportDetails.reportDetails.orderBy.find(ele => ele?.content?.key === pivotMeasure)

          if (!order) {
            reportDetails?.reportDetails?.orderBy?.push({
              id: res.result[0]._id,
              content: {
                key: pivotMeasure,
                order: res.result[0]?.type === 'number' ? 'desc' : res.result[0]?.type === 'string' ? 'asc' : 'asc'
              }
            })
          }

          updateReportDetails({ reportDetails: reportDetails?.reportDetails })
        }
      } else {
        reportDetails.reportDetails.measures = reportDetails?.reportDetails?.measures.filter(item => item.fieldName !== measure?.text)

        reportDetails.reportDetails.pivotConfig['value'].list = reportDetails?.reportDetails?.pivotConfig['value']?.list.filter(item => item?.text !== measure?.text)

        reportDetails.reportDetails.orderBy = reportDetails?.reportDetails?.orderBy.filter(ele => ele?.content?.key !== measure?.text)

        updateReportDetails({ reportDetails: reportDetails?.reportDetails })


      }
    }
  }

  const createCustomField = async (measure, item) => {
    const newMeasure = {
      name: '',
      dataSetId: '',
      dataSetType: 'MEASURE',
      type: '',
      sql: '',
      filter: [],
      format: '',
      calculatedField: '',
      isHidden: false
    };
    if (measure?.type === 'string') {

      let measureName = `${item?.text.split('.')[1]}Count`
      let params = { dataSetId: reportDetails?.reportDetails?.dataSetId?._id, search: measureName }
      const details = await getMeasuresList(params)
      if (details && !details?.result.length) {
        newMeasure.name = measure?.name + 'Count';
        newMeasure.type = 'count';
        newMeasure.sql = '${' + measure?.name + '}';
        newMeasure.dataSetId = measure?.dataSetId;
        newMeasure.calculatedField = `count(${measure?.name})`
        const res = await addMeasures(newMeasure);
        await addVersion({ version: new Date().getTime().toString() })
        let newField = {
          fieldName: reportDetails?.reportDetails?.dataSetId?.dataSetName + '.' + res?.result?.name,
          fieldId: res?.result?._id
        }
        reportDetails?.reportDetails?.measures.push(newField)
        reportDetails.reportDetails.dimensions = reportDetails?.reportDetails?.dimensions.filter(item => item?.fieldName.split('.')[1] !== measure?.name)

        const exist = reportDetails?.reportDetails?.pivotConfig['value']?.list.find(ele => ele?.text === newField?.fieldName)
        if (!exist) {

          reportDetails?.reportDetails?.pivotConfig['value']?.list.push({
            id: newField?.fieldId,
            text: newField?.fieldName,
            type: "measures"
          })
        }

        const order = reportDetails.reportDetails.orderBy.find(ele => ele?.content?.key === newField?.fieldName)

        if (!order) {
          reportDetails?.reportDetails?.orderBy?.push({
            id: newField?.fieldId,
            content: {
              key: newField?.fieldName,
              order: res?.result?.type === 'number' ? 'desc' : res?.result?.type === 'string' ? 'asc' : 'asc'
            }
          })
        }

        reportDetails.reportDetails.orderBy = reportDetails?.reportDetails?.orderBy.filter(ele => (ele?.content?.key).split('.')[1] !== measure?.name)

        reportDetails.reportDetails.pivotConfig['xAxis'].list = reportDetails?.reportDetails?.pivotConfig['xAxis']?.list.filter(item => item?.text.split('.')[1] !== measure?.name)
        reportDetails.reportDetails.pivotConfig['value'].list = reportDetails?.reportDetails?.pivotConfig['value']?.list.filter(item => item?.text.split('.')[1] !== measure?.name)

        updateReportDetails({ reportDetails: reportDetails?.reportDetails })
      }
      else {
        let newField = {
          fieldName: reportDetails?.reportDetails?.dataSetId?.dataSetName + '.' + details?.result[0]?.name,
          fieldId: details?.result[0]?._id
        }
        reportDetails?.reportDetails?.measures.push(newField)
        reportDetails.reportDetails.dimensions = reportDetails?.reportDetails?.dimensions.filter(item => item?.fieldName.split('.')[1] !== measure?.name)

        const exist = reportDetails?.reportDetails?.pivotConfig['value']?.list.find(ele => ele?.text === newField?.fieldName)
        if (!exist) {
          reportDetails?.reportDetails?.pivotConfig['value']?.list.push({
            id: newField?.fieldId,
            text: newField?.fieldName,
            type: "measures"
          })
        }
        const order = reportDetails?.reportDetails?.orderBy.find(ele => ele?.content?.key === newField?.fieldName)
        if (!order) {
          reportDetails?.reportDetails?.orderBy?.push({
            id: newField?.fieldId,
            content: {
              key: newField?.fieldName,
              order: details?.result[0]?.type === 'number' ? 'desc' : details?.result[0]?.type === 'string' ? 'asc' : 'asc'
            }
          })
        }
        reportDetails.reportDetails.orderBy = reportDetails?.reportDetails?.orderBy.filter(ele => (ele?.content?.key).split('.')[1] !== measure?.name)

        reportDetails.reportDetails.pivotConfig['xAxis'].list = reportDetails?.reportDetails?.pivotConfig['xAxis']?.list.filter(item => item?.text.split('.')[1] !== measure?.name)
        updateReportDetails({ reportDetails: reportDetails?.reportDetails })
      }
    }
    if (measure?.type === 'number') {

      let measureName = `${item?.text.split('.')[1]}Sum`
      let params = { dataSetId: reportDetails?.reportDetails?.dataSetId?._id, search: measureName }
      const details = await getMeasuresList(params)
      if (details && !details?.result.length) {

        newMeasure.name = measure?.name + 'Sum';
        newMeasure.type = 'sum';
        newMeasure.sql = '${' + measure?.name + '}';
        newMeasure.dataSetId = measure?.dataSetId;
        newMeasure.calculatedField = `sum(${measure?.name})`
        const res = await addMeasures(newMeasure);
        await addVersion({ version: new Date().getTime().toString() })
        let newField = {
          fieldName: reportDetails?.reportDetails?.dataSetId?.dataSetName + '.' + res?.result?.name,
          fieldId: res?.result?._id
        }
        reportDetails?.reportDetails?.measures.push(newField)
        reportDetails.reportDetails.dimensions = reportDetails?.reportDetails?.dimensions.filter(item => item?.fieldName.split('.')[1] !== measure?.name)
        const exist = reportDetails?.reportDetails?.pivotConfig['value']?.list.find(ele => ele?.text === newField?.fieldName)
        if (!exist) {
          reportDetails?.reportDetails?.pivotConfig['value']?.list.push({
            id: newField?.fieldId,
            text: newField?.fieldName,
            type: "measures"
          })
        }

        const order = reportDetails.reportDetails.orderBy.find(ele => ele?.content?.key === newField?.fieldName)

        if (!order) {
          reportDetails?.reportDetails?.orderBy?.push({
            id: newField?.fieldId,
            content: {
              key: newField?.fieldName,
              order: res?.result?.type === 'number' ? 'desc' : res?.result?.type === 'string' ? 'asc' : 'asc'
            }
          })
        }
        reportDetails.reportDetails.orderBy = reportDetails?.reportDetails?.orderBy.filter(ele => (ele?.content?.key).split('.')[1] !== measure?.name)


        reportDetails.reportDetails.pivotConfig['xAxis'].list = reportDetails?.reportDetails?.pivotConfig['xAxis']?.list.filter(item => item?.text.split('.')[1] !== measure?.name)
        updateReportDetails({ reportDetails: reportDetails?.reportDetails })
      }
      else {
        let newField = {
          fieldName: reportDetails?.reportDetails?.dataSetId?.dataSetName + '.' + details?.result[0]?.name,
          fieldId: details?.result[0]?._id
        }
        reportDetails?.reportDetails?.measures.push(newField)
        reportDetails.reportDetails.dimensions = reportDetails?.reportDetails?.dimensions.filter(item => item?.fieldName.split('.')[1] !== measure?.name)
        const exist = reportDetails?.reportDetails?.pivotConfig['value']?.list.find(ele => ele?.text === newField?.fieldName)
        if (!exist) {

          reportDetails?.reportDetails?.pivotConfig['value']?.list.push({
            id: newField?.fieldId,
            text: newField?.fieldName,
            type: "measures"
          })
        }
        reportDetails.reportDetails.pivotConfig['xAxis'].list = reportDetails?.reportDetails?.pivotConfig['xAxis']?.list.filter(item => item?.text.split('.')[1] !== measure?.name)
        updateReportDetails({ reportDetails: reportDetails?.reportDetails })
      }
    }
  }

  const onPivotDragEnd = ({ source, destination }) => {
    if (destination === undefined || destination === null) return null;

    if (source.droppableId === destination.droppableId && destination.index === source.index)
      return null;

    const start = reportDetails?.reportDetails?.pivotConfig[source.droppableId]
    const end = reportDetails?.reportDetails?.pivotConfig[destination.droppableId]

    if (start.id === end.id) {
      const newList = start.list.filter((_, idx) => idx !== source.index);
      newList.splice(destination.index, 0, start.list[source.index]);

      const newCol = { id: start.id, list: newList };
      reportDetails.reportDetails.pivotConfig[newCol.id] = newCol;

      updateReportDetails({ reportDetails: reportDetails.reportDetails })
      return null;
    }
    else {
      if (['table', 'bar', 'horizontalBar', 'pivotTable', 'scatter'].indexOf(reportDetails?.reportDetails?.chartType) < 0 && start?.list[source.index]?.text !== 'measures' && start?.id === 'xAxis' && end?.id === 'value') {
        let droppable = start.list[source.index]
        handleDimensionMeasureMapping(droppable)
      }
      else if (['table', 'bar', 'horizontalBar', 'pivotTable', 'scatter'].indexOf(reportDetails?.reportDetails?.chartType) < 0 && start?.list[source.index]?.text !== 'measures' && start?.id === 'value' && end?.id === 'xAxis') {
        let droppable = start.list[source.index]

        if ((droppable?.text).includes('Sum') || (droppable?.text).includes('Count')) {
          handleMeasureDimensionMapping(droppable)
        }

        else {
          const newStartList = start.list.filter((_, idx) => idx !== source.index);
          const newStartCol = {
            ...start,
            id: start.id,
            list: newStartList
          };
          const newEndList = end.list;
          newEndList.splice(destination.index, 0, start.list[source.index]);
          const newEndCol = {
            ...end,
            id: end.id,
            list: newEndList
          };
          reportDetails.reportDetails.pivotConfig[newStartCol.id] = newStartCol;
          reportDetails.reportDetails.pivotConfig[newEndCol.id] = newEndCol;
          updateReportDetails({ reportDetails: reportDetails.reportDetails })
          // Update the state
          setReportDetails((prevState) => ({
            ...prevState,
            [pivotConfig[newStartCol.id]]: newStartCol,
            [pivotConfig[newEndCol.id]]: newEndCol
          }));
        }
      }
      else {

        const newStartList = start.list.filter((_, idx) => idx !== source.index);
        const newStartCol = {
          ...start,
          id: start.id,
          list: newStartList
        };
        const newEndList = end.list;

        newEndList.splice(destination.index, 0, start.list[source.index]);

        if (end?.id === 'value') {
          newEndList.map(listObj => listObj.type = 'measures')
        }

        const newEndCol = {
          ...end,
          id: end.id,
          list: newEndList
        };

        reportDetails.reportDetails.pivotConfig[newStartCol.id] = newStartCol;
        reportDetails.reportDetails.pivotConfig[newEndCol.id] = newEndCol;

        updateReportDetails({ reportDetails: reportDetails.reportDetails })
        // Update the state
        setReportDetails((prevState) => ({
          ...prevState,
          [pivotConfig[newStartCol.id]]: newStartCol,
          [pivotConfig[newEndCol.id]]: newEndCol
        }));
      }
      return null;
    }
  }

  const onOpenSidebar = (menu) => {
    setOpen(true)
    setSelectedSidebarMenu(menu.title)

    if (menu.title === 'Visualize') {
      if (reportDetails)
        setChildren(<ReportVisualizeSettings reportDetails={reportDetails} updateReportDetails={updateReportDetails} isCalculatedFieldOpen={openCalculatedFields} setCommonFields={setCommonFields} currentUserType={currentUserType} />)
    }
    else if (menu.title === 'Filter') {
      setChildren(<ReportFilter reportDetails={reportDetails} updateReportDetails={updateReportDetails} />)
    }
    else if (menu.title === 'Settings') {
      setChildren(<ReportSettings reportDetails={reportDetails} updateReportDetails={updateReportDetails}
        measureTitle={measureTitle} dimensionTitle={dimensionTitle}
        handleMeasureTitleChange={handleMeasureTitleChange} handleDimensionTitleChange={handleDimensionTitleChange}
        handleSaveTitle={handleSaveTitle}
        commonFields={commonFields} setCommonFields={setCommonFields}
        hyperlinkCount={hyperlinkCount} setHyperlinkCount={setHyperlinkCount}
        setSelectedReportTab={setSelectedReportTab}
      />)
    }
  }

  const onCloseSidebar = (menu) => {
    setOpen(false)
  }


  const updateReport = (params) => {
    setSaveLoader(true)
    updateReportById(params)
      .then((res) => {
        toast.success(res.message)
        setSaveLoader(false)
      })
      .catch((err) => {
        toast.error("***Error***")
        setSaveLoader(false)
      })
  }

  const setPivot = (columns) => {
    const xArr = columns?.Xaxis?.list.map(ele => ele.text)
    const yArr = columns?.value?.list.map(ele => ele.text)
    const config = {
      x: yArr,
      y: xArr
    }
    if (reportDetails?.reportDetails) {
      reportDetails.reportDetails.pivotConfig = config
    }
  }

  const submitAddReport = (params) => {
    setSaveLoader(true)
    addReport(params)
      .then((res) => {
        toast.success(res.message)
        setSaveLoader(false)
        navigate(`/reportGraph/${res?.result?._id}?pageNo=1`)
      })
      .catch((err) => {
        toast.error("***Error***")
        setSaveLoader(false)
      })
  }

  // function getCallerTrace() {
  //   const error = new Error();
  //   const stackTrace = error.stack;
  //   const traceLines = stackTrace.split('\n');

  //   // Remove the first line (current function call)
  //   traceLines.shift();

  //   // Filter out irrelevant lines
  //   const callerTrace = traceLines.filter(line => line.includes('at '));

  //   return callerTrace.join('\n');
  // }

  const updateReportDetails = (value) => {
    setReportDetails(value)
  }

  const convertPivotConfig = (pivot, result) => {

    let config = {
      xAxis: {
        id: "xAxis",
        list: [],
        label: 'X Axis'
      },
      value: {
        id: "value",
        list: [],
        label: 'Value'
      },
      lines: {
        id: "Lines",
        list: [],
        label: 'Lines'
      },
      group: {
        id: "group",
        list: [],
        label: 'Group'
      },
    }

    config.lines.list = pivot?.lines || []
    config.group.list = pivot?.group || [];

    if (!pivot?.x?.length && !pivot?.y?.length && result && result?.dimensions?.length) {

      let dimensions = result?.dimensions.map((dim) => {
        return { text: dim?.fieldName, type: 'dimensions', id: dim?.fieldId }
      });

      config.xAxis.list = dimensions;
      config.value.list = [{ id: "1", text: "measures", type: "measures" }]

      return config;
    }
    else {
      const xArr = pivot?.x;
      const yArr = pivot?.y;
      let measures = xArr?.map((meas) => {
        return { text: meas, type: 'measures', id: Math.floor(Math.random() * 1000).toString() }
      });


      let dimensions = yArr?.map((dim) => {
        if (result?.dimensions?.find(dimObj => dimObj?.fieldName === dim)) {
          return { text: dim, type: 'measures', id: Math.floor(Math.random() * 1000).toString() }
        }
        return { text: dim, type: 'dimensions', id: Math.floor(Math.random() * 1000).toString() }
      });

      config.xAxis.list = measures;
      config.value.list = dimensions;

      return config;
    }
  }

  const formatOrderBy = (order, result) => {
    if (order && result) {
      const orderBy = Object.entries(order).map(([key, val]) => {
        return {
          id: Math.floor(Math.random() * 1000).toString(),
          content: {
            key: result?.dataSetId?.dataSetName + "." + key,
            order: val
          }
        }
      });
      return orderBy;
    }
    else if (!order?.length && result) {
      let order = [];
      if (result?.dimensions?.length) {
        for (let dim of result?.dimensions) {
          let obj = {
            id: dim?.fieldId,
            content: {
              key: dim?.fieldName,
              order: 'asc'
            }
          }
          order.push(obj)
        }
      }
      if (result?.measures?.length) {
        for (let meas of result?.measures) {
          let obj = {
            id: meas?.fieldId,
            content: {
              key: meas?.fieldName,
              order: 'desc'
            }
          }
          order.push(obj)
        }
      }
      return order;
    }
  }

  const handleReportHyperLink = (result) => {
    let dataSetName = null;
    if (result.dimensions?.length > 0) {
      dataSetName = result.dimensions[0]?.fieldName?.split('.')[0];
    }
    else if (result.measures?.length > 0) {
      dataSetName = result.measures[0]?.fieldName?.split('.')[0];
    }
    else if (result.timeDimensions?.length > 0 && result.timeDimensions[0].dimension) {
      dataSetName = result.timeDimensions[0].dimension?.split('.')[0]
    }
    let { reportHyperlink } = result;
    for (let link = 0; link < reportHyperlink.length; link++) {
      let { hyperlinkFilters } = reportHyperlink[link];
      if (hyperlinkFilters?.length) {
        hyperlinkFilters = hyperlinkFilters.map(f => ({ fieldName: `${dataSetName}.${f}` }))
      }
      commonFields[link] = hyperlinkFilters
    }
    setCommonFields(commonFields)
    setHyperlinkCount(reportHyperlink.length)

    return reportHyperlink
  }

  const fetchReportById = () => {
    let { id } = UrlParams
    if (id === 'new') {
      let reportDetails = {
        tabName: '',
        chartType: 'table',
        dataSetId: {},
        dimensions: [],
        timeDimensions: [],
        isDeleted: false,
        limit: 10,
        measures: [],
        orderBy: [],
        isLegendVisible: true,
        legendPosition: 'right',
        pivotConfig: {
          xAxis: {
            id: "xAxis",
            list: [],
            label: 'X Axis'
          },
          value: {
            id: "value",
            list: [{ id: "1", text: "measures" }],
            label: 'Value'
          },
          lines: {
            id: "Lines",
            list: [],
            label: 'Lines'
          },
          group: {
            id: "group",
            list: [],
            label: 'Group'
          }
        },
        reportFilters: [],
        reportName: 'New Report',
        noDataText: 'No Data',
        reportHyperlink: [{ hyperlinkColumn: '', hyperlinkDashboardId: null, hyperlinkColumnsForDashboard: [], hyperlinkReportId: {}, hyperlinkFilters: [], hyperlinkType: '', hyperlinkExtType: '', hyperlinkExtParams: [], hyperlinkExtQryParams: [{ name: '', field: '' }] }],
        renewQuery: false,
        settings: {
          showBarValueOnTop: false,
          barValuePosition: 'top',
          showDonutValue: true,
          showMultiColoredBar: true,
          showTogleToTable: false,
          mobile: {
            showXaxisLabel: true,
            horizontalScroll: true,
            maxBarsCount: 8,
            legendPagination: false,
            maxLegendsCount: 6,
            truncateLabel: true,
            maxLabelCharacters: 9
          },
          web: {
            showXaxisLabel: true,
            horizontalScroll: true,
            maxBarsCount: 20,
            legendPagination: false,
            maxLegendsCount: 6,
            truncateLabel: true,
            maxLabelCharacters: 12,
          },
          xAxisLabelDegree: 65,
          pageSize: 10,
          alignment: { header: 'left', dimensions: 'left' },
          conditionalFormat: [{}],
          rateChangeProps: {},
          dataFormat: {},
          axisTitle: { x: {}, y: {}, z: {} },
          axisSettings: { y: {} },
          groupBySettings: [],
          truncateSettings: [],
          downloadable: [{}],
        },
        linkedReportsViewType: 'TAB',
        linkedReportsViewCount: 1,
      }
      setReportDetails({ reportDetails })
    }
    else {
      let params = { reportId: id }

      validateUserReport(params)
        .then(resp => {
          if (resp && resp.length) {

            getReportById(params)
              .then((res) => {
                const pivotConfig = convertPivotConfig(res?.result?.pivotConfig, res?.result);
                const orderBy = formatOrderBy(res?.result?.orderBy, res?.result);
                res.result.pivotConfig = pivotConfig;
                res.result.orderBy = orderBy;
                res.result.noDataText = res.result?.noDataText || 'No Data'
                res.result.reportHyperlink = res.result.reportHyperlink && res.result.reportHyperlink.length ? handleReportHyperLink(res.result) : [{ hyperlinkColumn: '', hyperlinkReportId: {}, hyperlinkFilters: [], hyperlinkType: '', hyperlinkExtType: '', hyperlinkExtParams: [], hyperlinkExtQryParams: [{ name: '', field: '' }] }]
                formatReportTitle(res?.result)
                res.result.renewQuery = false
                res.result.linkedReports = mapLinkedResponseData(res.result)
                res.result.mergeReport = res.result.mergeReport || {}
                res.result.settings.conditionalFormat = res.result.settings.conditionalFormat || [{}]
                res.result.settings.pageSize = res.result.settings.pageSize || 10
                res.result.settings.xAxisLabelDegree = (res.result.settings.xAxisLabelDegree !== null && res.result.settings.xAxisLabelDegree !== undefined) ? res.result.settings.xAxisLabelDegree : 65;
                res.result.settings.alignment = res.result.settings.alignment || { header: 'left', dimensions: 'left' }
                res.result.settings.rateChangeProps = res.result.settings.rateChangeProps || {}
                res.result.settings.dataFormat = res.result.settings.dataFormat || {}
                res.result.settings.axisTitle = res.result.settings.axisTitle || { x: {}, y: {}, z: {} }
                res.result.settings.axisSettings = res.result.settings.axisSettings || { y: {} }
                res.result.settings.groupBySettings = res.result.settings.groupBySettings
                res.result.settings.truncateSettings = res.result.settings.truncateSettings
                res.result.settings.fillMissingDates = res.result.settings.fillMissingDates || false
                setReportDetails({ reportDetails: res.result })

              })
          }
          else {
            navigate('/report')
          }
        })

    }
  }


  // let currEndDate = moment().format("YYYY/MM/DD");
  // let currentStartDate = moment().subtract(29, "days").format("YYYY/MM/DD");
  // let prevEndDate = moment().subtract(29, "days").subtract(1, "days").format("YYYY/MM/DD");
  // let prevStartDate = moment().subtract(29, "days").subtract(1, "days").subtract(29, "days").format("YYYY/MM/DD");

  const mapLinkedResponseData = (reportData) => {
    let clonedReportData = _.cloneDeep(reportData)
    return clonedReportData?.linkedReports?.map(reportObj => {
      if(reportObj){
        const pivotConfig = convertPivotConfig(reportObj?.reportId?.pivotConfig, reportObj?.reportId);
        const orderBy = formatOrderBy(reportObj?.reportId?.orderBy, reportObj?.reportId);

        reportObj.reportName = reportObj?.reportId?.reportName
        if(reportObj.reportId){
          reportObj.reportId.pivotConfig = pivotConfig;
          reportObj.reportId.orderBy = orderBy;
        }        
      }
      return reportObj
    })
  }

  const formatReportTitle = (data) => {
    let dimensionTitle = {};
    let measureTitle = {};

    data?.dimensions?.map(dim => {
      let key = dim?.fieldName;
      dimensionTitle[key] = dim?.title
    })
    data?.measures?.map(meas => {
      let key = meas?.fieldName;
      measureTitle[key] = meas?.title
    });

    setMeasureTitle(measureTitle)
    setDimensionTitle(dimensionTitle)
  }

  const handleMobileAccess = (redirect = null) => {
    if (window.innerWidth < 900) {
      setRestrictOption(true);
    } else {
      setRestrictOption(false);
    }
  }

  useEffect(() => {
    handleMobileAccess();
    setReportDetails(reportDetails);
    setPivotConfig(pivotConfig);
  }, [pivotConfig])

  const updatePivotState = (pivot) => {
    setPivotConfig(pivot)
  }

  const handleDateFormatField = (dimensions) => {
    let dateFormat = {};
    dimensions?.map(dim => {
      if (dim?.dateFormat) {
        dateFormat[dim?.fieldName + '_date'] = dim?.dateFormat
      }
      else if (dim?.timeFormat) {
        dateFormat[dim?.fieldName + `_${dim?.timeFormatType}`] = dim?.timeFormat
      }
    })
    return dateFormat;
  }

  const handleColumnDisplayName = (report) => {
    const measures = report?.measures;
    const dimensions = report?.dimensions;
    const timeDimensions = report?.timeDimensions
    const displayObj = {};

    if (measures && measures.length) {
      measures.forEach(ele => {
        const { fieldName, displayName } = ele;
        if (displayName) {
          displayObj[fieldName] = displayName;
        }
      })
    }
    if (dimensions && dimensions.length) {
      dimensions.forEach(ele => {
        const { fieldName, displayName } = ele;
        if (displayName) {
          displayObj[fieldName] = displayName;
        }
      })
    }

    if (timeDimensions && timeDimensions.length) {
      timeDimensions.forEach(ele => {
        const { dimension, displayTitle, displayName } = ele;
        if (displayName) {
          displayObj[dimension] = displayTitle ? displayTitle : displayName ? displayName : dimension
        }
      })
    }
    return displayObj;
  }

  const handleMeasureFieldFormat = (measures) => {
    const formatObj = {}
    if (measures && measures.length) {
      measures.forEach(ele => {
        const { fieldName, fieldFormat } = ele;
        if (fieldFormat) {
          formatObj[fieldName] = fieldFormat;
        }
      })
    }
    return formatObj;
  }

  const handleReportFilters = (filters) => {
    if (filters.length) {
      return filters.map(f => {
        if (f?.operator === "top" || f?.operator === "bottom") {
          f = { ...f, operator: "equals" }
        }
        return f;
      })
    }
    else {
      return filters
    }
  }

  const handleFilterNullValues = (reportFilters) => {
    return reportFilters?.filter((item) => {
      if ((item.operator === 'set' || item.operator === 'notSet') ||
        (item?.values?.length > 0 && (!item?.values.includes(null) && !item?.values?.includes("")))) {
        return item
      }
    })?.map(f => {
      if (f.operator === 'set' || f.operator === 'notSet') {
        return {
          member: f?.member, operator: f?.operator
        }
      } else {
        return {
          member: f?.member, operator: f?.operator, values: f?.values
        }
      }
    })
  }

  const getHiddenFields = (fields) => {
    let fieldsArr = []
    if (fields.length) {
      for (let field of fields) {
        if (field?.isHidden) {
          fieldsArr.push(field?.fieldName)
        }
      }
    }
    return fieldsArr;
  }

  const handleReportFields = (reportFields) => {
    let fieldsArr = []
    if (reportFields.length) {
      for (let fields of reportFields) {
        // if (!fields?.isHidden) {
        fieldsArr.push(fields?.fieldName)
        // }
      }
    }
    return fieldsArr;
  }
  useEffect(() => fetchReportById(), [])

  const getReportFieldsKey = () => {
    let info = { measureKey: [], dimensionKey: [] }
    if (reportDetails?.reportDetails?.measures.length) {
      info.measureKey = reportDetails?.reportDetails?.measures.map(meas => meas?.fieldName)
    }
    if (reportDetails?.reportDetails?.dimensions.length) {
      info.dimensionKey = reportDetails?.reportDetails?.dimensions.map(dim => dim?.fieldName)
    }
    return info
  }

  const handleRateChangeQuery = (reportDetailsQuery) => { 
    if ((reportDetailsQuery?.settings?.rateChangeProps?.periodicity || reportDetailsQuery?.settings?.rateChangeProps?.customVal)
      && (reportDetailsQuery?.timeDimensions?.length || reportDetailsQuery?.settings?.rateChangeProps?.dateField)) {
      const reportFilters = handleReportFilters(reportDetailsQuery?.reportFilters)
      const { periodicity, customVal } = reportDetailsQuery?.settings?.rateChangeProps
      let granularityDimension = reportDetailsQuery?.settings?.rateChangeProps?.dateField || reportDetailsQuery?.timeDimensions[0]?.dimension;

      const queryProps = { chartType: reportDetailsQuery?.chartType, settings: reportDetailsQuery?.settings, query: [] }
      const showYearOnYearChange = reportDetailsQuery?.settings?.rateChangeProps?.showYearOnYearChange || false;

      for (let i = 0; i < 2; i++) {
        let query = {
          measures: handleReportFields(reportDetailsQuery?.measures),
          order: handleQueryOrderBy(reportDetailsQuery?.orderBy),
          dimensions: handleReportFields(reportDetailsQuery?.dimensions),
          limit: reportDetailsQuery?.limit,
          timezone: 'UTC',
          timeDimensions: reportDetailsQuery?.timeDimensions,
          filters: handleFilterNullValues(reportFilters),
          renewQuery: reportDetailsQuery?.renewQuery
        }

        if (periodicity && !customVal) {
          switch (periodicity) {
            case 'daily':
              if (i === 0) {
                query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Yesterday", "granularity": "day" }]
              }
              else {
                query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Today", "granularity": "day" }]
              }
              break;
            case 'weekly':
              if (i === 0) {
                query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Last Week", "granularity": "week" }]
              }
              else {
                query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "This Week", "granularity": "week" }]
              }
              break;
            case 'monthly':
              if (i === 0) {
                query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Last Month", "granularity": "month" }]
              }
              else {
                query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "This Month", "granularity": "month" }]
              }
              break;

            case 'quarterly':
              if (i === 0) {
                query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Last Quarter", "granularity": "quarter" }]

              }
              else {
                query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "This Quarter", "granularity": "quarter" }]
              }
              break;
            case 'yearly':
              if (i === 0) {
                query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Last Year", "granularity": "year" }]
              }
              else {
                query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "This Year", "granularity": "year" }]
              }
              break;
            default:
              return
          }
        }
        else {
          let customVal = reportDetailsQuery?.settings?.rateChangeProps?.customVal
          customVal = parseInt(customVal)
          let granularity;
          if (customVal === 1) {
            granularity = 'day';
          }
          else if (customVal > 1 && customVal < 7) {
            granularity = 'weeek';
          }
          else if (customVal >= 7 && customVal < 30) {
            granularity = 'month';
          }
          else if (customVal >= 30 && customVal < 120) {
            granularity = 'quarter';
          }
          else {
            granularity = 'year';
          }

          let currEndDate = moment().format("YYYY/MM/DD");
          let currentStartDate = moment().subtract((customVal - 1), "days").format("YYYY/MM/DD");
          let prevEndDate = moment().subtract(customVal, "days").format("YYYY/MM/DD");
          let prevStartDate = moment().subtract(customVal, "days").subtract(customVal - 1, "days").format("YYYY/MM/DD");

          const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);

          if (new Date(prevStartDate) < startDate) {
            granularity = 'year'
          }
          else {
            granularity = 'month'
          }

          if (i === 0) {
            query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": [prevStartDate, prevEndDate], "granularity": granularity }]
          }
          else {
            query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": [currentStartDate, currEndDate], "granularity": granularity }]
          }
        }
        queryProps.query.push(query)
      }

      if(showYearOnYearChange){
        const yoyQuery = {
          measures: handleReportFields(reportDetailsQuery?.measures),
          order: handleQueryOrderBy(reportDetailsQuery?.orderBy),
          dimensions: handleReportFields(reportDetailsQuery?.dimensions),
          limit: reportDetailsQuery?.limit,
          timezone: 'UTC',
          timeDimensions: reportDetailsQuery?.timeDimensions,
          filters: handleFilterNullValues(reportFilters),
          renewQuery: reportDetailsQuery?.renewQuery
        }
        if(periodicity && !customVal){
          let start, end, granularity;

          switch (periodicity) {
            case "daily": {
              start = moment()
                .startOf("day")
                .subtract(1, "year")
                .format("YYYY-MM-DD");
              end = moment()
                .endOf("day")
                .subtract(1, "year")
                .format("YYYY-MM-DD");
              granularity = "day";
              break;
            }

            case "weekly": {
              start = moment()
                .startOf("week")
                .subtract(1, "year")
                .format("YYYY-MM-DD");
              end = moment()
                .endOf("week")
                .subtract(1, "year")
                .format("YYYY-MM-DD");
              granularity = "week";
              break;
            }

            case "monthly": {
              start = moment()
                .startOf("month")
                .subtract(1, "year")
                .format("YYYY-MM-DD");
              end = moment()
                .endOf("month")
                .subtract(1, "year")
                .format("YYYY-MM-DD");
              granularity = "month";
              break;
            }

            case "quarterly": {
              start = moment()
                .startOf("quarter")
                .subtract(1, "year")
                .format("YYYY-MM-DD");
              end = moment()
                .endOf("quarter")
                .subtract(1, "year")
                .format("YYYY-MM-DD");
              granularity = "quarter";
              break;
            }

            case "yearly": {
              start = moment()
                .startOf("year")
                .subtract(1, "year")
                .format("YYYY-MM-DD");
              end = moment()
                .endOf("year")
                .subtract(1, "year")
                .format("YYYY-MM-DD");
              granularity = "year";
              break;
            }

            default:
              return;
          }

          yoyQuery.timeDimensions = [{ "dimension": granularityDimension, "dateRange": [start, end], "granularity": granularity }]
          
        }
        else {
          let customVal = reportDetailsQuery?.settings?.rateChangeProps?.customVal
          customVal = parseInt(customVal)
          let granularity;
          if (customVal === 1) {
            granularity = 'day';
          }
          else if (customVal > 1 && customVal < 7) {
            granularity = 'weeek';
          }
          else if (customVal >= 7 && customVal < 30) {
            granularity = 'month';
          }
          else if (customVal >= 30 && customVal < 120) {
            granularity = 'quarter';
          }
          else {
            granularity = 'year';
          }

        let prevEndDate = moment().subtract(1,"years").format("YYYY/MM/DD");
        let prevStartDate = moment().subtract((customVal - 1), "days").subtract(1,"years").format("YYYY/MM/DD");
    
          granularity = queryProps?.query[0]?.timeDimensions?.[0]?.granularity || granularity;
          yoyQuery.timeDimensions = [{ "dimension": granularityDimension, "dateRange": [prevStartDate, prevEndDate], "granularity": granularity }]
        }
        queryProps.query.push(yoyQuery)
      }

      return queryProps
    }
    return null
  }

  const mapResponseForQuery = useCallback((reportDetailsQuery) => {
    let tempQuery = { vizState: {} }
    tempQuery.name = reportDetailsQuery?.reportName
    const dateFormat = handleDateFormatField(reportDetailsQuery?.dimensions)
    const colDisplayName = handleColumnDisplayName(reportDetailsQuery)
    const fieldFormat = handleMeasureFieldFormat(reportDetailsQuery?.measures)
    const reportFilters = handleReportFilters(reportDetailsQuery?.reportFilters)
    tempQuery.report = reportDetailsQuery

    tempQuery.vizState = {
      chartType: reportDetailsQuery?.chartType,
      query: {
        measures: handleReportFields(reportDetailsQuery?.measures),
        order: handleQueryOrderBy(reportDetailsQuery?.orderBy),
        dimensions: handleReportFields(reportDetailsQuery?.dimensions),
        limit: reportDetailsQuery?.limit,
        timezone: 'UTC',
        filters: handleFilterNullValues(reportFilters),
        renewQuery: reportDetailsQuery?.renewQuery,
        timeDimensions: reportDetailsQuery?.timeDimensions,
      },
      pivotConfig: handlePivotConfigFormat(reportDetailsQuery?.pivotConfig),
      columnState: reportDetailsQuery?.columnState,
      orderBy:reportDetailsQuery?.orderBy,
      isPivotEnabled: reportDetailsQuery?.isPivotEnabled,
      isLegendVisible: reportDetailsQuery?.isLegendVisible,
      legendPosition: reportDetailsQuery?.legendPosition,
      columnTitle: [{ ...dimensionTitle, ...measureTitle }],
      dateFieldFormat: dateFormat,
      columnDisplayName: colDisplayName,
      fieldFormat: fieldFormat,
      noDataText: reportDetailsQuery?.noDataText,
      reportHyperlink: reportDetailsQuery?.reportHyperlink || [],
      settings: reportDetailsQuery?.settings,
      rateChangeQuery: handleRateChangeQuery(reportDetailsQuery),
      toggleToTable: reportDetailsQuery?.toggleToTable,
      viewMode: 'report',
      reportName: reportDetailsQuery?.reportName,
      description: reportDetailsQuery?.description,
      fieldsKeyInfo: getReportFieldsKey(),
      hiddenFields: getHiddenFields([...reportDetailsQuery?.measures, ...reportDetailsQuery?.dimensions]),
      comparisonChartType: reportDetailsQuery?.comparisonChartType,
    }
    tempQuery.vizState.query.filters = tempQuery.vizState.query.filters?.map((item) => {
      if (item.operator === 'set' || item.operator === 'notSet') {
        return { member: item.member, operator: item.operator }
      }
      if (item?.member && item?.operator && item?.values?.length > 0)
        return { member: item.member, operator: item.operator, values: item.values }
    })
    return tempQuery
  })

  const handleSaveOrderBy = (order) => {
    let orderBy = {};
    order.forEach(ele => {
      orderBy[(ele.content.key).split('.')[1]] = ele?.content?.order;
    })
    return orderBy;
  }

  const handleQueryOrderBy = (order) => {
    let orderBy = {};
    order?.forEach(ele => {
      orderBy[ele?.content?.key] = ele?.content?.order;
    })
    return orderBy;
  }

  const handleSavePivotConfigFormat = (pivot) => {
    const xArr = pivot?.xAxis?.list.map(ele => ele.text)
    const yArr = pivot?.value?.list.map(ele => ele.text)
    const lines = pivot?.lines?.list
    const group = pivot?.group?.list

    const config = {
      x: xArr,
      y: yArr,
      lines,
      group,
    }

    return config
  }

  const handlePivotConfigFormat = (pivot) => {
    let xArr = pivot?.xAxis?.list.map(ele => ele.text)
    let yArr = []

    if (pivot?.group?.list) {
      yArr = [...pivot?.group?.list.map(ele => ele?.text), ...pivot?.value?.list.map(ele => ele?.text)]
    }
    else {
      yArr = [...pivot?.value?.list.map(ele => ele?.text)]
    }

    let lines = pivot?.lines?.list
    let group = pivot?.group?.list

    const config = {
      x: xArr,
      y: yArr,
      lines,
      group,
    }

    return config
  }

  const handleSaveReport = () => {
    let { id } = UrlParams
    let folderId = new URLSearchParams(queryParams).get('folderId');

    let { reportName } = reportDetails?.reportDetails ?? {}

    if (reportName) {
      reportName = reportName.trim()
    }

    if (!reportName) {
      toast.error('Report Name is required')
      return false
    }
    // else if (containsSpecialCharacter(reportName)) {
    //   toast.error('Special characters are not allowed in report name.')
    //   return false
    // }

    let params = {
      reportName: reportDetails.reportDetails.reportName,
      tabName: reportDetails.reportDetails.tabName,
      carouselName: reportDetails.reportDetails.carouselName,
      carouselDescription: reportDetails.reportDetails.carouselDescription,
      dataSetId: reportDetails.reportDetails.dataSetId._id,
      chartType: reportDetails.reportDetails.chartType,
      comparisonChartType: reportDetails.reportDetails.comparisonChartType,
      measures: JSON.stringify(
        reportDetails.reportDetails.measures.map((obj) => {
          return { fieldName: obj.fieldName, fieldId: obj.fieldId, title: obj?.title, displayName: obj?.displayName, fieldFormat: obj?.fieldFormat, isHidden: obj?.isHidden }
        })
      ),
      dimensions: JSON.stringify(
        reportDetails.reportDetails.dimensions.map((obj) => {
          return { fieldName: obj.fieldName, fieldId: obj.fieldId, title: obj?.title, dateFormat: obj?.dateFormat, displayName: obj?.displayName, timeFormat: obj?.timeFormat, timeFormatType: obj?.timeFormatType, isHidden: obj?.isHidden }
        })
      ),
      reportFilters: JSON.stringify(
        reportDetails.reportDetails.reportFilters
      ),
      orderBy: handleSaveOrderBy(reportDetails?.reportDetails?.orderBy),
      limit: reportDetails.reportDetails.limit || 10,
      pivotConfig: handleSavePivotConfigFormat(reportDetails?.reportDetails?.pivotConfig),
      columnState: JSON.stringify(getPivotColState()),
      isPivotEnabled: getTablePivotState(),
      isLegendVisible: reportDetails?.reportDetails?.isLegendVisible,
      legendPosition: reportDetails?.reportDetails?.legendPosition,
      timeDimensions: JSON.stringify(reportDetails?.reportDetails?.timeDimensions),
      formatVisual: reportDetails?.reportDetails?.formatVisual,
      description: reportDetails?.reportDetails?.description,
      noDataText: reportDetails?.reportDetails?.noDataText,
      reportHyperlink: JSON.stringify(reportDetails?.reportDetails?.reportHyperlink),
      settings: reportDetails?.reportDetails?.settings,
      linkedReports: reportDetails?.reportDetails?.linkedReports ?? [],
      linkedReportsViewType: reportDetails?.reportDetails?.linkedReportsViewType,
      linkedReportsViewCount: reportDetails?.reportDetails?.linkedReportsViewCount,
      linkedReportsViewCountMobile: reportDetails?.reportDetails?.linkedReportsViewCountMobile,
      quickFilterList: reportDetails?.reportDetails?.quickFilterList,
      mergeReport: reportDetails?.reportDetails?.mergeReport,
      joinFlag: reportDetails?.reportDetails?.joinFlag || false
    }

    if (reportDetails?.reportDetails && id !== 'new') {
      params['reportId'] = id || reportDetails.reportDetails._id

      updateReport(params)
    }else if (reportDetails?.reportDetails && id === 'new') {

      if (folderId) {
        params.folderId = folderId
      }

      submitAddReport(params)
    }
  }

  const refreshFieldList = () => {
    fetchReportById()
  }

  const handleChangeFilterFromList = (obj, index, e) => {
    // e.target.value = typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value;

    // reportDetails.reportDetails.reportFilters[index].values = e.target.value;

    updateReportDetails({ reportDetails: reportDetails.reportDetails });
  }

  const handleTimePeriodFilter = (value, obj, i, dateType) => {
    const { startDate, endDate } = generateCustomDateRange(value)
    let newDates = [startDate, endDate]
    reportDetails.reportDetails.reportFilters[i].values = newDates;
    reportDetails.reportDetails.reportFilters[i].dateFilterProps.selectedTimePeriod = value;
    updateReportDetails({ reportDetails: reportDetails.reportDetails });
  }


  const handleDateFilter = (e, obj, i, dateType) => {
    let value = e;
    let timeFlag = obj?.dateFilterProps && obj?.dateFilterProps?.dateRangeType === "dateTime" ? true:false
    
    if (moment(value).isValid()) {
      value = moment(value).format("YYYY-MM-DD HH:mm:ss")
    }
    else {
      value = ''
    }
    let newDates = [...obj.values]
    //console.log(timeFlag,obj)
    switch (dateType) {
      case 'startDate':
        newDates[0] = value
        break
      case 'endDate':
        newDates[1] =   value && !timeFlag ? moment(value).endOf('day').format('YYYY-MM-DD HH:mm:ss') : value
        break
      case 'singleDate':
        newDates[0] = value
        break
    }
    //console.log(newDates)
    if (newDates[0] && newDates[1]) {
      const startDate = new Date(newDates[0]);
      const timestamp1 = startDate.getTime();

      const endDate = new Date(newDates[1]);
      const timestamp2 = endDate.getTime();

      if (timestamp1 && timestamp2 && (timestamp1 > timestamp2)) {
        // [newDates[0], newDates[1]] = [newDates[1], newDates[0]];
        toast.error("Start date cannot be after End Date")
        return
      }
    }

    reportDetails.reportDetails.reportFilters[i].values = newDates;
    updateReportDetails({ reportDetails: reportDetails.reportDetails });
  }

  const handleReportName = (e) => {
    let { value } = e.target
    reportDetails.reportDetails.reportName = value
    updateReportDetails({ reportDetails: reportDetails.reportDetails })
  }

  const handleReportDescription = (e) => {
    let { value } = e.target
    reportDetails.reportDetails.description = value
    updateReportDetails({ reportDetails: reportDetails.reportDetails })
  }

  const handleReportLimit = (e) => {
    let { value } = e.target
    if (value < 1) {
      toast.error("Limit cannot be less than 1");
    } else {
      reportDetails.reportDetails.limit = value
      updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }
  }

  const getPivotColState = () => {
    let colState = gridColumnApi?.getColumnState()
    return (colState ? colState : [])
  }

  const getTablePivotState = () => {
    let pivotState = gridColumnApi?.isPivotMode()
    return (pivotState || false)
  }

  const toggleTitlePopup = (params) => {
    setOpenPopup(params)
  }

  const handleOrderMenu = (e, item) => {
    e.stopPropagation()
    orderAnchorEl[item.content.key] = e?.currentTarget
    setOrderAnchorEl(orderAnchorEl)
    setSelectedOrder({ item: item })
  }

  const handleOrderSelect = (e) => {
    e.stopPropagation()
    const order = e?.target?.attributes?.value?.value;
    if (selectedOrder && order) {
      for (let item of reportDetails?.reportDetails?.orderBy) {
        if (item?.content?.key === selectedOrder?.item?.content?.key) {
          item.content.order = order;
          break;
        }
      }
      updateReportDetails({ reportDetails: reportDetails?.reportDetails })
      handleOrderClose()
      toast.success('Order Updated')
    }
  }

  const handleSaveTitle = (e) => {
    reportDetails.reportDetails.measures = reportDetails?.reportDetails?.measures?.map(meas => {
      let title = measureTitle[meas?.fieldName];
      meas.title = title
      return meas;
    })
    reportDetails.reportDetails.dimensions = reportDetails?.reportDetails?.dimensions?.map(dim => {
      let title = dimensionTitle[dim?.fieldName];
      dim.title = title
      return dim;
    })

    updateReportDetails({ reportDetails: reportDetails.reportDetails })
    toggleTitlePopup(false)
  }

  const handleMeasureTitleChange = (e, fieldName) => {
    let { value } = e?.target
    measureTitle = { ...measureTitle, [fieldName]: value }
    setMeasureTitle(measureTitle)
  }

  const handleDimensionTitleChange = (e, fieldName) => {
    let { value } = e?.target
    dimensionTitle = { ...dimensionTitle, [fieldName]: value }
    setDimensionTitle(dimensionTitle)
  }

  useEffect(() => {
    console.log(reportDetails)
    onOpenSidebar({ title: selectedSidebarMenu })
  }, 
  [reportDetails])

  useEffect(() => {
    validateUserRole().then(res => {
      if (res && res?.userType && res?.userType?.length) {
        setCurrentUserType(res?.userType[0])
      }
    })
  }, [])

  const handleDeleteReportFilterPopUp = (obj) => {
    setDeleteObj({ ...obj })
    setDeletePopup(true)
  }

  const handleToggleHideReportFilter = (obj) => {
    //console.log('obj', obj)
    let index = reportDetails?.reportDetails?.reportFilters?.findIndex(filter => filter.member === obj.member && filter.operator === obj.operator && filter.filterOrder === obj.filterOrder);

    if (index >= 0) {
      reportDetails.reportDetails.reportFilters[index].hidden = !reportDetails.reportDetails.reportFilters[index].hidden ?? true;
      updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }
  }

  const handleDeleteReportFilter = () => {
    let obj = _.cloneDeep(deleteObj);
    let index = reportDetails?.reportDetails?.reportFilters?.findIndex(f => (f.member === obj?.member && f.operator === obj?.operator && f.filterOrder === obj?.filterOrder))


    if (index >= 0) {
      let filterObj = reportDetails.reportDetails.reportFilters[index];
      delete filterObj.listType;
      // delete filterObj.displayName;
      delete filterObj.selectAll;
      delete filterObj.specificValue;
      delete filterObj.valuesList;

      if (filterObj?.useRelevant && filterObj?.useRelevant.length) {
        for (let rel of filterObj?.useRelevant) {
          for (let index = 0; index < reportDetails?.reportDetails?.reportFilters.length; index++) {
            const filter = reportDetails?.reportDetails?.reportFilters[index]
            if (rel?.relevantMember === filter?.member) {
              filter.relevantTo = '';
              filter.relevantValues = []
              reportDetails.reportDetails.reportFilters[index] = filter
            }
          }
        }
      }
      delete filterObj?.relevantTo

      reportDetails.reportDetails.reportFilters[index] = filterObj;
      updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }
    setDeleteObj({})
    setDeletePopup(false)
  }

  const handleCancelDelete = () => {
    setDeletePopup(false)
    setDeleteObj({});
  }

  const handleEditReportFilter = (obj, index) => {
    if (obj) {
      if (obj?.valuesList?.length)
        obj.valuesList = obj?.valuesList?.join("\n");

      setRecordForEdit({ ...obj, index })
      getMeasureList()
      setOpenPopupFilter(true)
    }
  }

  const closeEditFilter = () => {
    setRecordForEdit({})
    setOpenPopupFilter(false)
  }

  const addOrEdit = (form, resetForm) => {
    resetForm()
    setOpenPopupFilter(false);

    if (form.specificValue)
      form.valuesList = form?.valuesList?.split('\n');
    else
      form.valuesList = null;

    let { member, values, operator, type, displayName, listType, specificValue, valuesList, selectAll, dataSetType, useDbData, relevantTo, useRelevant, dynamicLabel, dateFilterProps } = form;
    let filterObj = { member, values, operator, type, displayName, listType, specificValue, valuesList, selectAll, dataSetType, useDbData, relevantTo, useRelevant, dynamicLabel, dateFilterProps }

    reportDetails.reportDetails.reportFilters[form?.index] = filterObj;
    updateReportDetails({ reportDetails: reportDetails.reportDetails })
  }

  const handleLegendVisibility = (e) => {
    let { checked } = e.target
    reportDetails.reportDetails.isLegendVisible = checked;
    updateReportDetails({ reportDetails: reportDetails.reportDetails })
  }

  const handleLegendPosition = e => {
    let { value } = e.target
    reportDetails.reportDetails.legendPosition = value;
    updateReportDetails({ reportDetails: reportDetails.reportDetails })
  }


  const handleSettingsExpand = (panel) => (event, newExpanded) => {
    setExpandedSettings(newExpanded ? panel : false);
  };

  const toggleCalculatedFields = (params) => {
    setOpenCalculatedFields(params)
  }

  const closeCalcltdFldDialog = () => {
    setOpenCalculatedFields(false)
  }

  const fetchMeasureList = () => {
    setOpenCalculatedFields(false)
  }

  const getMeasureList = () => {
    if (reportDetails?.reportDetails?.dataSetId?._id) {
      let params = { dataSetId: reportDetails?.reportDetails?.dataSetId?._id, sortKey: 'name', sortOrder: 1 }
      getMeasuresList(params)
        .then((res) => {
          setMeasureList(res.result);
        });
    }
  }

  const validateMeasuresDimension = ({ measures, dimensions, timeDimensions, chartType, comparisonChartType }) => {
    if (comparisonChartType) return true
    let measuresL = measures?.length || 0;
    let dimensionsL = (dimensions?.length || 0) + (timeDimensions?.length || 0);

    if (!(measuresL || dimensionsL))
      return false;

    const staticGraphType = StaticGraphTypesConfig.find((obj) => obj.value === chartType);

    if (staticGraphType) {
      const { operator, minDimension, minMeasure, maxDimension, maxMeasure } = staticGraphType?.requireField;

      if (operator) {
        if (operator === "minOr" && ((dimensionsL < minDimension) && (measuresL < minMeasure)))
          return false;
        else if (operator === "minAnd_maxAnd" && !((dimensionsL >= minDimension) && (measuresL >= minMeasure)))
          return false;
        else if (operator === "minAnd_maxAnd" && !((dimensionsL <= maxDimension) && (measuresL <= maxMeasure)))
          return false;
        return true
      }
    } else if (chartType === 'numberGraphicCard') {
      // handle the numberGraphicCard which is part if number chart
      const { minMeasure } = GraphTypesConfig.find((obj) => obj.value === 'number');

      if (minMeasure && measuresL < minMeasure)
        return false;
      return true;
    } else {
      const graphType = GraphTypesConfig.find((obj) => obj.value === chartType);

      const { operator, minDimension, minMeasure, maxDimension, maxMeasure } = graphType?.requireField;

      if (operator) {
        if (operator === "minOr" && ((dimensionsL < minDimension) && (measuresL < minMeasure)))
          return false;
        else if (operator === "minAnd_maxAnd" && !((dimensionsL >= minDimension) && (measuresL >= minMeasure)))
          return false;
        else if (operator === "minAnd_maxAnd" && !((dimensionsL <= maxDimension) && (measuresL <= maxMeasure)))
          return false;
      } else {
        if (minDimension && dimensionsL < minDimension)
          return false;
        else if (minMeasure && measuresL < minMeasure)
          return false;
        else if (maxDimension && dimensionsL > maxDimension)
          return false;
        else if (maxMeasure && measuresL > maxMeasure)
          return false;
      }
      return true;

    }
  }

  const [anchorFieldWellsEl, setAnchorFieldWellsEl] = useState(null);
  const handleFieldWellsClick = (event) => {
    const fieldWellsWidthVal = fieldWellsRef.current.clientWidth;
    setFieldWellsWidth(fieldWellsWidthVal);
    setAnchorFieldWellsEl(event.currentTarget);
  };
  const handleFieldWellsClose = () => {
    setAnchorFieldWellsEl(null);
  };

  const [anchorOrderByEl, setAnchorOrderByEl] = useState(null);
  const handleOrderByClick = (event) => {
    const fieldWellsWidthVal = fieldWellsRef.current.clientWidth;
    setFieldWellsWidth(fieldWellsWidthVal);
    const fieldWellsLeftPositionVal = fieldWellsRef.current.offsetLeft;
    setFieldWellsLeftPosition(fieldWellsLeftPositionVal);
    const fieldWellsRightPositionVal = fieldWellsRef.current.offsetRight;
    setFieldWellsRightPosition(fieldWellsRightPositionVal - 58);
    setAnchorOrderByEl(event.currentTarget);
  };
  const handleOrderByClose = () => {
    setAnchorOrderByEl(null);
  };

  const handleSubmitDeleteReport = async () => {
    let { id } = UrlParams

    if (id === 'new') {
      toast.error('Report is not saved yet!')
    }
    else {
      let response = await deleteReport({ reportId: id })
      if (response?.result) {
        toast.success(response.message)
        navigate('/report')
      }
      else if (response?.data?.statusCode === 0) {
        toast.error(response?.data?.error?.errorMessage)
      }
    }
  }


  const handleSubmitSaveAs = (details) => {
    let { duplicateReportDesc, duplicateReportName } = details

    let params = {
      reportName: duplicateReportName,
      tabName: reportDetails.reportDetails.tabName,
      description: duplicateReportDesc,
      dataSetId: reportDetails.reportDetails.dataSetId._id,
      chartType: reportDetails.reportDetails.chartType,
      measures: JSON.stringify(
        reportDetails.reportDetails.measures.map((obj) => {
          return { fieldName: obj.fieldName, fieldId: obj.fieldId, title: obj?.title, displayName: obj?.displayName, fieldFormat: obj?.fieldFormat, isHidden: obj?.isHidden }
        })
      ),
      dimensions: JSON.stringify(
        reportDetails.reportDetails.dimensions.map((obj) => {
          return { fieldName: obj.fieldName, fieldId: obj.fieldId, title: obj?.title, dateFormat: obj?.dateFormat, displayName: obj?.displayName, timeFormat: obj?.timeFormat, timeFormatType: obj?.timeFormatType, isHidden: obj?.isHidden }
        })
      ),
      reportFilters: JSON.stringify(
        reportDetails.reportDetails.reportFilters
      ),
      orderBy: handleSaveOrderBy(reportDetails?.reportDetails?.orderBy),
      limit: reportDetails.reportDetails.limit || 10,
      pivotConfig: handleSavePivotConfigFormat(reportDetails?.reportDetails?.pivotConfig),
      columnState: JSON.stringify(getPivotColState()),
      isPivotEnabled: getTablePivotState(),
      isLegendVisible: reportDetails?.reportDetails?.isLegendVisible,
      legendPosition: reportDetails?.reportDetails?.legendPosition,
      timeDimensions: JSON.stringify(reportDetails?.reportDetails?.timeDimensions),
      formatVisual: reportDetails?.reportDetails?.formatVisual,
      noDataText: reportDetails?.reportDetails?.noDataText,
      reportHyperlink: JSON.stringify(reportDetails?.reportDetails?.reportHyperlink),
      settings: reportDetails?.reportDetails?.settings,
      linkedReports: reportDetails?.reportDetails?.linkedReports ?? [],
      linkedReportsViewType: reportDetails?.reportDetails?.linkedReportsViewType,
      linkedReportsViewCount: reportDetails?.reportDetails?.linkedReportsViewCount
    }
    submitSaveAsReport(params)
  }

  const submitSaveAsReport = (params) => {
    setSaveLoader(true)
    addReport(params).then((res) => {
      toast.success(res.message)
      setSaveLoader(false)
      handleSaveAsPoup('cancel')
    })
  }

  const handleSaveAsPoup = (type) => {
    switch (type) {
      case 'open':
        setSaveAsPopup(true)
        break
      case 'cancel':
        setSaveAsPopup(false)
        break
    }
  }

  const handleDeleteReportPopup = (type) => {
    switch (type) {
      case 'open':
        setDeleteReportPopup(true)
        break
      case 'cancel':
        setDeleteReportPopup(false)
        break
    }
  }

  const [filterMoreEl, setFilterMoreEl] = useState(null);
  const openFilterMoreMenu = Boolean(filterMoreEl);
  const handleFilterMoreMenuClick = (event) => {
    if (filterMoreEl !== event.currentTarget) {
      setFilterMoreEl(event.currentTarget);
    }
  };
  const handleFilterMoreMenuClose = () => {
    setFilterMoreEl(null);
  };

  const getItemDisplayName = (item) => {
    const itemText = item?.content?.key;
    const measures = reportDetails?.reportDetails?.measures;
    const dimensions = reportDetails?.reportDetails?.dimensions;
    let displayName;

    for (let dim of dimensions) {
      if (dim?.fieldName === itemText) {
        displayName = dim?.displayName;
        break;
      }
    }
    if (!displayName) {
      for (let meas of measures) {
        if (meas?.fieldName === itemText) {
          displayName = meas?.displayName;
          break;
        }
      }
    }
    return displayName ? displayName : itemText?.split('.')[1]
  }

  const getFilterLabel = (filterObj) => {
    let { displayName, operator, listType } = filterObj

    if (GREATER_LESS_THAN_FILTER.includes(operator) && listType === 'inputValue') {
      return `${displayName} ${NUMBER_FILTER_TYPE[operator]}`;
    }

    if (displayName && displayName.length && displayName?.includes('select') || displayName?.includes('Select') || displayName?.includes('SELECT')) {
      return displayName;
    }
    else {
      return `${displayName}`;
    }
  }

  const convertToTable = () => {
    let clonedReportDetails = _.cloneDeep(reportDetails)
    let { linkedReports } = clonedReportDetails?.reportDetails

    if (selectedReportTab > 0 && linkedReports?.length && linkedReports?.[selectedReportTab - 1]?.reportId) {
      linkedReports[selectedReportTab - 1].reportId.toggleToTable = !linkedReports?.[selectedReportTab - 1]?.reportId.toggleToTable
    }
    else {
      clonedReportDetails.reportDetails.toggleToTable = !clonedReportDetails.reportDetails.toggleToTable
    }

    updateReportDetails({ reportDetails: clonedReportDetails.reportDetails })
  }

  const viewLinkedReport = (e, newValue) => {
    if (reportDetails?.reportDetails?.linkedReports?.[newValue - 1]?.reportId) {
      formatReportTitle(reportDetails?.reportDetails?.linkedReports?.[newValue - 1]?.reportId)
    }
    setSelectedReportTab(newValue)
  }

  const viewLinkedReportCarousel = (newValue) => {
    if (reportDetails?.reportDetails?.linkedReports?.[newValue - 1]?.reportId) {
      formatReportTitle(reportDetails?.reportDetails?.linkedReports?.[newValue - 1]?.reportId)
    }
    setSelectedReportTab(newValue)
  }


  useEffect(() => {
    return () => {
      //Here we will cancel all API is progress for this component
      if (source) {
        source.cancel("Get Report Details API");
      }
    }
  }, []);

  useEffect(() => {
    let rSettings = reportDetails?.reportDetails?.settings;
    let rBgColor;
    let rGridBgColor;
    let rBorderColor;
    let rIsBorder;
    let rIsCarouselElevation;
    let rCarouselElevationColor;
    //let rIsCarouselCardTitle;
    let rCarouselCardSpacing;
    let rIsCarouselCardElevation;
    let rCarouselCardElevationColor;
    let rHasBgColor;

    if (isMobileView()) {
      rGridBgColor = rSettings?.mobile?.reportShowGridBackgroundColor ? rSettings?.mobile?.reportGridBgColor : null;
      rHasBgColor = rSettings?.mobile?.reportShowBackgroundColor;
      rBgColor = rSettings?.mobile?.reportShowBackgroundColor ? rSettings?.mobile?.reportBgColor : null;
      rBorderColor = rSettings?.mobile?.reportShowBorderColor ? rSettings?.mobile?.reportBorderColor : null;
      rIsBorder = rSettings?.mobile?.reportShowBorderColor;
      rIsCarouselElevation = rSettings?.mobile?.reportIsCarouselElevation || 0;
      rCarouselElevationColor = rSettings?.mobile?.reportIsCarouselElevation ? rSettings?.mobile?.reportCarouselElevationColor : null;
      //rIsCarouselCardTitle = rSettings?.mobile?.reportIsCarouselCardTitle;
      rCarouselCardSpacing = rSettings?.mobile?.reportCarouselCardSpacing || '0';
      rIsCarouselCardElevation = rSettings?.mobile?.reportIsCarouselCardElevation || 0;
      rCarouselCardElevationColor = rSettings?.mobile?.reportIsCarouselCardElevation ? rSettings?.mobile?.reportCarouselCardElevationColor : null;

    } else {
      rGridBgColor = rSettings?.web?.reportShowGridBackgroundColor ? rSettings?.web?.reportGridBgColor : null;
      rHasBgColor = rSettings?.web?.reportShowBackgroundColor;
      rBgColor = rSettings?.web?.reportShowBackgroundColor ? rSettings?.web?.reportBgColor : null;
      rBorderColor = rSettings?.web?.reportShowBorderColor ? rSettings?.web?.reportBorderColor : null;
      rIsBorder = rSettings?.web?.reportShowBorderColor;
      rIsCarouselElevation = rSettings?.web?.reportIsCarouselElevation || 0;
      rCarouselElevationColor = rSettings?.web?.reportIsCarouselElevation ? rSettings?.web?.reportCarouselElevationColor : null;
      //rIsCarouselCardTitle = rSettings?.web?.reportIsCarouselCardTitle;
      rCarouselCardSpacing = rSettings?.web?.reportCarouselCardSpacing || '0';
      rIsCarouselCardElevation = rSettings?.web?.reportIsCarouselCardElevation || 0;
      rCarouselCardElevationColor = rSettings?.web?.reportIsCarouselCardElevation ? rSettings?.web?.reportCarouselCardElevationColor : null;
    }
    
    setReportGridBgColor(rGridBgColor);
    setReportHasBgColor(rHasBgColor);
    setReportBgColor(rBgColor);
    setReportHasBorder(rIsBorder);
    setReportBorderColor(rBorderColor);
    //setReportIsCarouselCardTitle(rIsCarouselCardTitle);
    setReportCarouselCardSpacing(rCarouselCardSpacing);
    setReportCarouselElevationColor(rCarouselElevationColor);
    setReportCarouselCardElevationColor(rCarouselCardElevationColor);
    setReportHasCarouselElevation(rIsCarouselElevation);
    setReportHasCarouselCardElevation(rIsCarouselCardElevation);
  }, [reportDetails?.reportDetails?.settings]);

  let { settings, toggleToTable, chartType, linkedReports, tabName, linkedReportsViewType, linkedReportsViewCount, linkedReportsViewCountMobile } = reportDetails?.reportDetails ?? {}
  return (
    <RootStyle>
      <MeasureListContextProvider>
        <ReportDetailsContextProvider reportDetails={reportDetails?.reportDetails} updateReportDetails={updateReportDetails}>
          <ComparisonChartDetailsContextProvider>
            <QuickFilterContextProvider>
              <ReportSideBar onOpenSidebar={onOpenSidebar} isOpenSidebar={open} onCloseSidebar={onCloseSidebar} selectedSidebarMenu={selectedSidebarMenu} />
              <MainStyleWrapper className="report-new-wrapper report-page-wrapper">

                <ReportHeader onSaveLoader={saveLoader} onhandleSaveReport={handleSaveReport} onChangeReportName={handleReportName}
                  reportNameValue={reportDetails?.reportDetails?.reportName || ''}
                  currentUserType={currentUserType}
                  onSettingsToggle={toggleTitlePopup}
                  onOpenCalculatedFields={toggleCalculatedFields} handleReportDescription={handleReportDescription}
                  description={reportDetails?.reportDetails?.description || ''}
                  onOpenSidebar={onOpenSidebar}
                  handleSaveAsPoup={handleSaveAsPoup}
                  handleDeleteReportPopup={handleDeleteReportPopup}
                  exportPDFWithMethod={exportPDFWithMethod}
                  mapResponseForQuery={mapResponseForQuery}
                  reportDetails={reportDetails}
                  setExportProcessDialog={setExportProcessDialog}
                  columnTitle={[{ ...dimensionTitle, ...measureTitle }]}
                  columnDisplayName={handleColumnDisplayName(reportDetails?.reportDetails)}
                />
                
                <Grid container spacing={2} className="report-new-content" >
                  <Grid item xs={12} md={open ? 4 : 0} className="report-new-main-fields" sx={{ display: (open) ? 'block' : 'none' }} alignItems="stretch"  >
                    <ReportSettingsSidebar isOpenSidebar={open} children={children} />
                  </Grid>
                  <Grid item xs={12} md={open ? 8 : 0} className="report-new-main-content" alignItems="stretch"  >
                    <Grid className="report-new-main-content-section" sx={{ height: '100%' }}>
                      <Grid container className="config_wrapper width-100" ref={fieldWellsRef}>
                        <Grid item className="config_wrapper_left" mt={1} xs={12} sm={8} md={8}>
                          <Grid
                            id="fieldwell-button-id"
                            aria-controls="fieldwell-button-menu"
                            aria-haspopup="true"
                            aria-expanded={Boolean(anchorFieldWellsEl) ? 'true' : undefined}
                            onClick={handleFieldWellsClick}
                            className="report_form_ui_btn bg-white width-98 width-100-sm color-text-main form_ui_input_border"
                            justifyContent="space-between"
                            display="flex"
                            alignItems="center"
                          >
                            <Typography className={classes.heading} style={{ color: 'gray', fontWeight: '500', fontSize: '14px' }}>Field wells</Typography>
                            <DropDownIcon />
                          </Grid>
                          <Menu
                            id="fieldwell-button-menu"
                            MenuListProps={{
                              'aria-labelledby': 'fieldwell-button-id',
                            }}
                            PaperProps={{
                              style: {
                                width: fieldWellsWidth, height: 'fit-content', maxHeight: '300px', borderTopLeftRadius: 0,
                                borderTopRightRadius: 0
                              },
                            }}
                            anchorEl={anchorFieldWellsEl}
                            open={Boolean(anchorFieldWellsEl)}
                            onClose={handleFieldWellsClose}
                          >
                            <DragDropContext onDragEnd={onPivotDragEnd}>
                              <Grid container direction={"row"} justify={"center"}>
                                {reportDetails?.reportDetails?.pivotConfig && Object.values(reportDetails?.reportDetails?.pivotConfig)?.map((column) => {
                                  return (
                                    <Grid item key={column.id}>
                                      {column.id !== 'Lines' ? <Column column={column} key={column.id} reportDetails={reportDetails} updateReportDetails={updateReportDetails} setPivotConfig={updatePivotState} pivotConfig={pivotConfig} /> :
                                        (reportDetails.reportDetails.chartType === 'clusteredBarCombo' || reportDetails.reportDetails.chartType === 'stackedBarCombo' || reportDetails.reportDetails.chartType === 'multiAxisBarCombo') ? <Column column={column} key={column.id} reportDetails={reportDetails} updateReportDetails={updateReportDetails} setPivotConfig={updatePivotState} pivotConfig={pivotConfig} /> : null}
                                    </Grid>
                                  );
                                })}
                              </Grid>
                            </DragDropContext>
                          </Menu>


                        </Grid>
                        <Grid item className="config_wrapper_right" mt={1} ml={0} sm={4} xs={12} md={4} >
                          <Grid
                            id="orderby-button-id"
                            aria-controls="orderby-button-menu"
                            aria-haspopup="true"
                            aria-expanded={Boolean(anchorOrderByEl) ? 'true' : undefined}
                            onClick={handleOrderByClick}
                            className="report_form_ui_btn bg-white width-100 color-text-main form_ui_input_border"
                            justifyContent="space-between"
                            display="flex"
                            alignItems="center"
                          >
                            <Typography className={classes.heading} style={{ color: 'gray', fontWeight: '500', fontSize: '14px' }}>Order By</Typography>
                            <DropDownIcon />
                          </Grid>
                          <Menu
                            id="orderby-button-menu"
                            MenuListProps={{
                              'aria-labelledby': 'orderby-button-id',
                            }}
                            PaperProps={{
                              style: {
                                width: fieldWellsWidth, height: 'fit-content', maxHeight: '300px', borderTopLeftRadius: 0,
                                borderTopRightRadius: 0, right: fieldWellsRightPosition
                              },
                            }}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}

                            anchorEl={anchorOrderByEl}
                            open={Boolean(anchorOrderByEl)}
                            onClose={handleOrderByClose}
                          >
                            <DragDropContext onDragEnd={onOrderDragEnd} onDragUpdate={onOrderDragUpdate}>

                              <Droppable droppableId="droppable">
                                {(provided, snapshot) => (
                                  <div
                                    {...provided?.droppableProps}
                                    ref={provided?.innerRef}
                                  // style={getOrderListStyle(snapshot?.isDraggingOver)}
                                  >
                                    <Grid container sx={{ mx: 2 }} className="orderByBlock"  >
                                      {reportDetails?.reportDetails?.orderBy && reportDetails?.reportDetails?.orderBy.map((item, index) => (
                                        <Grid item key={index} className="orderByBlockItem" >
                                          <Draggable key={item?.id + index} draggableId={item?.id} index={index}>
                                            {(provided, snapshot) => (
                                              <Box
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getOrderItemStyle(
                                                  snapshot?.isDragging,
                                                  provided.draggableProps.style
                                                )}
                                                className="orderByBlockItemContent"
                                                key={index}
                                              >
                                                <Typography className='orderByBlockItemContentTxt' component="div" variant="body2">{getItemDisplayName(item)}</Typography>
                                                <Button
                                                  mt={2}
                                                  variant="contained"
                                                  className="order_button"
                                                  color="primary"
                                                  onClick={e => handleOrderMenu(e, item)}

                                                  endIcon={<AngleDownIcon />}
                                                >
                                                </Button>
                                                <Menu
                                                  id="order-menu"
                                                  anchorEl={orderAnchorEl[item?.content?.key]}
                                                  keepMounted
                                                  open={Boolean(orderAnchorEl[item?.content?.key])}
                                                  onClose={handleOrderClose}
                                                  onClick={e => handleOrderSelect(e)}
                                                >
                                                  <MenuItem className={item?.content?.order === 'asc' && 'visualize_list_text'} value="asc" >Asc</MenuItem>
                                                  <MenuItem className={item?.content?.order === 'desc' && 'visualize_list_text'} value="desc">Desc</MenuItem>
                                                </Menu>
                                              </Box>
                                            )}
                                          </Draggable>
                                        </Grid>
                                      ))}
                                    </Grid>
                                    {provided.placeholder}
                                    <div style={{
                                      position: "absolute",
                                      top: orderplaceholderProps.clientY,
                                      left: orderplaceholderProps.clientX,
                                      height: orderplaceholderProps.clientHeight,
                                      // background: "#f6f6f6",
                                      width: orderplaceholderProps.clientWidth
                                    }} />
                                  </div>
                                )}
                              </Droppable>

                            </DragDropContext>
                          </Menu>

                        </Grid>
                      </Grid>
                      <MainStyle>
                        <Outlet />


                        {
                          (
                            LimitAllowedIn.includes(reportDetails?.reportDetails?.chartType)
                            && (reportDetails?.reportDetails?.measures?.length || reportDetails?.reportDetails?.dimensions?.length)
                            && !(reportDetails?.reportDetails?.reportFilters.find(f => f?.operator === "top" || f?.operator === "bottom"))
                          )
                            ? (<Limit handleReportLimit={handleReportLimit} limitValue={reportDetails?.reportDetails?.limit} />)
                            : null
                        }

                        <Grid className={classes.graphFiltergrid} sx={{ marginBottom: '1rem' }} >
                          <Box sx={{ flexGrow: 1 }}>
                            <Box className="dashboard-view-filters-container" >
                              {
                                reportDetails?.reportDetails?.reportFilters?.map((obj, i) => (
                                  obj?.listType
                                    ? (
                                      <Box key={i} className="dashboard-filters-view-item" >
                                        <Box>
                                          <Grid xs={12} item display="flex" >
                                            <Grid>
                                              <Typography className="report-form-label text-left" variant="body2" > {getFilterLabel(obj)} </Typography>
                                            </Grid>
                                            <Grid>
                                              <MaterialMenu icon={<SettingIcon />}
                                                onClose={handleFilterMoreMenuClose}
                                                options={[
                                                  { label: 'Edit', func: () => handleEditReportFilter(obj, i) },
                                                  { label: 'Delete', func: () => handleDeleteReportFilterPopUp(obj) },
                                                  { label: obj?.hidden ? 'Unhide' : 'Hide', func: () => handleToggleHideReportFilter(obj) }
                                                ]}
                                              />
                                            </Grid>
                                          </Grid>
                                          {
                                            obj.operator === "inDateRange" || obj.operator === "notInDateRange" ?
                                              <FilterDateRangeView obj={obj} i={i} handleDateFilter={handleDateFilter} showLabel={false} handleTimePeriodFilter={handleTimePeriodFilter} />
                                              :
                                              obj.operator === "beforeDate" || obj.operator === "afterDate" ?
                                                <FilterSingleDate obj={obj} i={i} handleDateFilter={handleDateFilter} showLabel={false} />
                                                :
                                                obj?.listType === 'inputValue' ?
                                                  <FilterGreaterLessValue handleChangeFilterFromList={handleChangeFilterFromList} filterCondtion={obj} i={i}
                                                    reportDetails={reportDetails}
                                                    updateReportDetails={updateReportDetails} />
                                                  :
                                                  (obj?.listType === "dropdown" ?
                                                    <FormControl variant="outlined" sx={{ width: '100%' }} size="small">
                                                      <FilterSelectValue handleChangeFilterFromList={handleChangeFilterFromList} filterCondtion={obj} i={i}
                                                        reportDetails={reportDetails}
                                                        updateReportDetails={updateReportDetails}
                                                        onLoader={false}
                                                      />
                                                    </FormControl>
                                                    :
                                                    <FormControl variant="outlined" sx={{ width: '100%' }} size="small">
                                                      <FilterMultipleSelectValue handleChangeFilterFromList={handleChangeFilterFromList} filterCondtion={obj} i={i}
                                                        reportDetails={reportDetails}
                                                        updateReportDetails={updateReportDetails}
                                                        onLoader={false}
                                                      />
                                                    </FormControl>
                                                  )
                                          }
                                        </Box>
                                      </Box>
                                    )
                                    : null
                                ))
                              }
                            </Box>
                          </Box>
                        </Grid>
                        <Grid item xs={12} className="report-graph-section" ref={reportContainerRef} >
                          <Box className={`report-graph-section-wrapper `
                            + (reportBgColor ? ` has-bg ` : ``)
                            + ((reportHasBorder) ? ` has-border ` : ``)
                            + ((reportHasCarouselElevation) ? ` has-elevation ` : ``)
                            + ((reportHasCarouselCardElevation) ? ` has-card-elevation ` : ``)}
                            sx={{
                              backgroundColor: (reportBgColor ? reportBgColor : 'transparent'),
                              borderWidth: (reportHasBorder ? '1px' : '0px'), borderStyle: 'solid',
                              borderColor: reportBorderColor ? reportBorderColor : '#dedede',
                              boxShadow: (reportHasCarouselElevation ? `0px 0px 6px ${reportCarouselElevationColor ?? '#DEDEDE'}` : 'none'),
                            }}
                          >
                            <Box className='' display="flex" justifyContent="flex-end">

                              {selectedReportTab > 0 ? (linkedReports?.[selectedReportTab - 1]?.reportId?.settings?.showTogleToTable && linkedReports?.[selectedReportTab - 1]?.reportId?.chartType !== 'table' ?
                                <MButton className='report-graph-icon-type' onClick={convertToTable} title='Toggle View'>
                                  {linkedReports?.[selectedReportTab - 1]?.reportId?.toggleToTable ? <GraphIcon /> : <TableIcon />}
                                </MButton> : null) :
                                settings?.showTogleToTable && chartType !== 'table' ?
                                  <MButton className='report-graph-icon-type' onClick={convertToTable} title='Toggle View'>
                                    {toggleToTable ? <GraphIcon /> : <TableIcon />}
                                  </MButton> : null}
                            </Box>

                            {linkedReportsViewType === 'CAROUSEL' && linkedReports?.length ?
                              <Box className={`number_chart_card_carousel ` + settings?.numberChartTemplate?.template + ` ` + chartContainerWidth} ref={chartContainerRef}>
                                <Box >
                                  <Box className={`chart-carousel ` + (isMobileView() ? 'chart-carousel-mobile' : ``)} sx={{ width: '100%', height: '100%' }}>
                                    <Box className='number_chart_carousel_heading'>
                                      <Typography variant="h6" className="number_chart_carousel_title" title={reportDetails?.reportDetails?.reportName}
                                      >{handleStringLength(reportDetails?.reportDetails?.reportName, NumberChartTitleLength)}</Typography>
                                      <Typography variant="body2" className="number_chart_carousel_subtitle" title={reportDetails?.reportDetails?.description}
                                      >{handleStringLength(reportDetails?.reportDetails?.description, NumberChartDescriptionLength)}</Typography>
                                    </Box>
                                    {
                                      (reportDetails?.reportDetails?.chartType === 'number' || reportDetails?.reportDetails?.chartType === 'numberGraphicCard')
                                        ? <Slider
                                            speed={500}
                                            arrows={isMobileView() ? false : true}
                                            slidesToScroll={1}
                                            //slidesToShow={(window.innerWidth < 1024) ? (isMobileView() ? 1.1 : 2.1) : (window.innerWidth < 1600 ? 2.5 : 3.5)}
                                            slidesToShow={(isMobileView()
                                              ? linkedReportsViewCountMobile
                                              : ((settings?.numberChartTemplate?.template === 'template2')
                                                ? (chartContainerWidth / ((215 + (reportHasCarouselCardElevation ? 40 : 0)) + parseInt(reportCarouselCardSpacing))) // 32px is left & right padding. 8px for elevation margin between
                                                : linkedReportsViewCount
                                              )
                                            ) ?? 1}
                                            centerMode={false}
                                            swipeToSlide={true}
                                            infinite={false}
                                            centerPadding={isMobileView() ? '10px' : '20px'}
                                            //centerPadding={reportCarouselCardSpacing + 'px'}
                                            nextArrow={isMobileView() ? null : <CarouselNextArrow />}
                                            prevArrow={isMobileView() ? null : <CarouselPrevArrow />}
                                          >
      
                                            {reportDetails?.reportDetails && (reportDetails?.reportDetails?.comparisonChartType || validateMeasuresDimension(reportDetails?.reportDetails)) ? (
                                              <Card id={`report-${reportDetails?.reportId?._id}`} variant="outlined" className={"number_chart_card " + settings?.numberChartTemplate?.template} >
                                                <Box className="" sx={{ boxShadow: `0px 0px 4px ${reportHasCarouselCardElevation ? (reportCarouselCardElevationColor ?? '#DEDEDE') : 'none'}` }}>
      
                                                  <Box className='number_chart_card_heading'>
                                                    {
                                                      reportDetails?.reportDetails?.carouselName ?
                                                        <Typography variant="h6" className="number_chart_title" title={reportDetails?.reportDetails?.carouselName}
                                                        >{handleStringLength(reportDetails?.reportDetails?.carouselName, NumberChartTitleLength)}</Typography>
                                                        : null
                                                    }
                                                    {
                                                      reportDetails?.reportDetails?.carouselDescription ?
                                                        <Typography variant="body2" className="number_chart_subtitle" title={reportDetails?.reportDetails?.carouselDescription}
                                                        >{handleStringLength(reportDetails?.reportDetails?.carouselDescription, NumberChartDescriptionLength)}</Typography>
                                                        : null
                                                    }
      
                                                  </Box>
                                                  <Box className="number_chart_value" >
                                                    <ReportGraph
                                                      reportDetails={mapResponseForQuery(reportDetails.reportDetails)}
                                                      getPivotColState={getPivotColState}
                                                      gridColumnApi={gridColumnApi}
                                                      setGridColumnApi={setGridColumnApi}
                                                    />
                                                  </Box>
                                                </Box>
                                              </Card>
                                            ) : (<EmptyChart chartType={reportDetails?.reportDetails?.chartType} />)}
      
                                            {linkedReports?.map((reportObj, i) => (
                                              <Card id={`report-${reportObj?.reportId?._id}`} key={i} variant="outlined" className={"number_chart_card " + settings?.numberChartTemplate?.template} >
                                                <Box className="" sx={{ boxShadow: `0px 0px 4px ${reportHasCarouselCardElevation ? (reportCarouselCardElevationColor ?? '#DEDEDE') : 'none'}` }}>
      
                                                  <Box className='number_chart_card_heading'>
                                                    {
                                                      reportObj?.carouselName ?
                                                        <Typography variant="h6" title={reportObj?.carouselName} className="number_chart_title"
                                                        >{handleStringLength(reportObj?.carouselName, NumberChartTitleLength)}</Typography>
                                                        : null
                                                    }
                                                    {
                                                      reportObj?.carouselDescription ?
                                                        <Typography variant="body2" className="number_chart_subtitle" title={reportObj?.carouselDescription}
                                                        >{handleStringLength(reportObj?.carouselDescription, NumberChartDescriptionLength)}</Typography>
                                                        : null
                                                    }
      
                                                  </Box>
                                                  <Box className="number_chart_value" >
                                                    <ReportGraph
                                                      reportDetails={mapResponseForQuery({ ...reportObj?.reportId, carouselName: reportObj?.carouselName, carouselDescription: reportObj?.carouselDescription })}
                                                      getPivotColState={getPivotColState}
                                                      gridColumnApi={gridColumnApi}
                                                      setGridColumnApi={setGridColumnApi}
                                                    />
                                                  </Box>
                                                </Box>
                                              </Card>
                                            ))}
      
      
                                          </Slider>

                                        : <>
                                          <Box className={`re-carousel-wrapper `
                                            + (linkedReports?.length ? ` dash-report-has-linked-reports ` : ` `)
                                            }>
                                            <Swiper
                                            spaceBetween={parseInt(reportCarouselCardSpacing)}
                                            slidesPerView={(isMobileView() ? linkedReportsViewCountMobile : linkedReportsViewCount) ?? 1}
                                            //slidesPerView={'auto'}
                                            modules={[Navigation]}
                                            navigation={isMobileView() ? false : {
                                              prevEl: ".swiper-prev-arrow",
                                              nextEl: ".swiper-next-arrow",
                                            }}
                                            className='swiper-slider'
                                            >
                                              {reportDetails?.reportDetails && (reportDetails?.reportDetails?.comparisonChartType || validateMeasuresDimension(reportDetails?.reportDetails)) ? (
                                                <SwiperSlide key={reportDetails?.reportId?._id} >
                                                  <Card id={`report-${reportDetails?.reportId?._id}`} variant="outlined" className={"number_chart_card " + settings?.numberChartTemplate?.template} >
                                                    <Box className="" sx={{ boxShadow: `0px 0px 4px ${reportHasCarouselCardElevation ? (reportCarouselCardElevationColor ?? '#DEDEDE') : 'none'}` }}>
          
                                                      <Box className='number_chart_card_heading'>
                                                        {
                                                          reportDetails?.reportDetails?.carouselName ?
                                                            <Typography variant="h6" className="number_chart_title" title={reportDetails?.reportDetails?.carouselName}
                                                            >{handleStringLength(reportDetails?.reportDetails?.carouselName, NumberChartTitleLength)}</Typography>
                                                            : null
                                                        }
                                                        {
                                                          reportDetails?.reportDetails?.carouselDescription ?
                                                            <Typography variant="body2" className="number_chart_subtitle" title={reportDetails?.reportDetails?.carouselDescription}
                                                            >{handleStringLength(reportDetails?.reportDetails?.carouselDescription, NumberChartDescriptionLength)}</Typography>
                                                            : null
                                                        }
          
                                                      </Box>
                                                      <Box className="number_chart_value" >
                                                        <ReportGraph
                                                          reportDetails={mapResponseForQuery(reportDetails.reportDetails)}
                                                          getPivotColState={getPivotColState}
                                                          gridColumnApi={gridColumnApi}
                                                          setGridColumnApi={setGridColumnApi}
                                                        />
                                                      </Box>
                                                    </Box>
                                                  </Card>
                                                </SwiperSlide>
                                              ) : (<SwiperSlide key={reportDetails?.reportId?._id} ><EmptyChart chartType={reportDetails?.reportDetails?.chartType} /></SwiperSlide>)}
        
                                              {linkedReports?.map((reportObj, i) => (
                                                <SwiperSlide key={reportObj?.reportId?._id} >
                                                  <Card id={`report-${reportObj?.reportId?._id}`} variant="outlined" className={"number_chart_card " + settings?.numberChartTemplate?.template} >
                                                    <Box className="" sx={{ boxShadow: `0px 0px 4px ${reportHasCarouselCardElevation ? (reportCarouselCardElevationColor ?? '#DEDEDE') : 'none'}` }}>
          
                                                      <Box className='number_chart_card_heading'>
                                                        {
                                                          reportObj?.carouselName ?
                                                            <Typography variant="h6" title={reportObj?.carouselName} className="number_chart_title"
                                                            >{handleStringLength(reportObj?.carouselName, NumberChartTitleLength)}</Typography>
                                                            : null
                                                        }
                                                        {
                                                          reportObj?.carouselDescription ?
                                                            <Typography variant="body2" className="number_chart_subtitle" title={reportObj?.carouselDescription}
                                                            >{handleStringLength(reportObj?.carouselDescription, NumberChartDescriptionLength)}</Typography>
                                                            : null
                                                        }
          
                                                      </Box>
                                                      <Box className="number_chart_value" >
                                                        <ReportGraph
                                                          reportDetails={mapResponseForQuery(reportObj?.reportId)}
                                                          getPivotColState={getPivotColState}
                                                          gridColumnApi={gridColumnApi}
                                                          setGridColumnApi={setGridColumnApi}
                                                        />
                                                      </Box>
                                                    </Box>
                                                  </Card>
                                                </SwiperSlide>
                                              ))}
                                            </Swiper>
                                          
                                            {
                                              isMobileView() 
                                                ? null
                                                : <>
                                                    <CarouselPrevArrow className="swiper-nav-arrow swiper-prev-arrow " />
                                                    <CarouselNextArrow className="swiper-nav-arrow swiper-next-arrow" />
                                                  </>
                                            }
                                          </Box>
                                        </>
                                    }
                                    
                                  </Box>
                                </Box>
                              </Box>

                              : <>
                                {linkedReports?.length ? <Tabs
                                  value={selectedReportTab}
                                  onChange={viewLinkedReport}
                                  sx={{ mb: 2 }}
                                  variant="scrollable"
                                  scrollButtons="auto"
                                  aria-label="wrapped label tabs example"
                                  className='report-graph-tabs-container scrollable-tabs'
                                  TabIndicatorProps={{
                                    sx: {
                                      backgroundColor: 'transparent',
                                    },
                                    children: <span />
                                  }}
                                >
                                  <Tab className="tab-item" value={0}
                                    label={
                                      <Grid container alignItems="center" justify="center" className="tab-item-box" >
                                        <Box sx={{ width: '100%' }}>
                                          <Typography variant='h5' className='tab-item-label' >{tabName?.trim()?.length ? tabName : reportDetails?.reportDetails?.reportName}</Typography>
                                        </Box>
                                      </Grid>
                                    }
                                  />
                                  {linkedReports?.map((reportObj, i) => (
                                    <Tab key={i} className="tab-item" value={i + 1}
                                      label={
                                        <Grid container alignItems="center" justify="center" className="tab-item-box">
                                          <Box sx={{ width: '100%' }}>
                                            <Typography variant='h5' className='tab-item-label' >{reportObj?.tabName?.trim()?.length ? reportObj?.tabName : reportObj.reportName}</Typography>
                                          </Box>
                                        </Grid>
                                      }
                                    />
                                  ))}
                                </Tabs> : null}

                                {selectedReportTab > 0 ? (<ReportGraph
                                  reportDetails={mapResponseForQuery(linkedReports?.[selectedReportTab - 1]?.reportId)}
                                  getPivotColState={getPivotColState}
                                  gridColumnApi={gridColumnApi}
                                  setGridColumnApi={setGridColumnApi}
                                />) : reportDetails?.reportDetails && validateMeasuresDimension(reportDetails?.reportDetails) ? (
                                  <ReportGraph
                                    reportDetails={mapResponseForQuery(reportDetails.reportDetails)}
                                    getPivotColState={getPivotColState}
                                    gridColumnApi={gridColumnApi}
                                    setGridColumnApi={setGridColumnApi}
                                  />
                                ) : (
                                  <EmptyChart chartType={reportDetails?.reportDetails?.chartType} />
                                )}
                              </>}

                          </Box>

                        </Grid>
                      </MainStyle>
                    </Grid>
                  </Grid>
                </Grid>

              </MainStyleWrapper>

              <ReportSaveAsDialog openPoup={saveAsPopup} handleSubmitSaveAs={handleSubmitSaveAs} handleSaveAsPoup={handleSaveAsPoup} />
              <DeleteReportDialog openPoup={deleteReportPopup} handleDeleteReportPopup={handleDeleteReportPopup} handleSubmitDeleteReport={handleSubmitDeleteReport} />

              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className="modal-root"
                open={openPopupFilter}
                onClose={closeEditFilter}
                closeAfterTransition
              >
                <Fade in={openPopupFilter}>
                  <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
                    <CloseIcon onClick={closeEditFilter} className="enlarge-close" />
                    <Box className="modal-header modal-header2" >
                      <Typography variant="subtitle1" className="modal-header-title" >{`Edit Filter`}</Typography>
                    </Box>
                    <Box className="modal-content modal-content2">
                      <FormatControl addOrEdit={addOrEdit} recordForEdit={recordForEdit} reportDetails={reportDetails} updateReportDetails={updateReportDetails} measureList={measureList}
                        labelType="placeholder" alignType="center" action="edit" />
                    </Box>
                  </Box>
                </Fade>
              </Modal>

              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className="modal-root"
                open={deletePopup}
                onClose={() => false}
                closeAfterTransition
              >
                <Fade in={deletePopup}>
                  <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
                    <Box className="modal-content-simple">
                      <Typography variant="subtitle1" className="modal-heading-title-simple">{`Are you sure to delete this filter "${deleteObj?.displayName}" ?`}</Typography>
                      <Box className="modal-footer-simple">
                        <MButton onClick={handleCancelDelete} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </MButton>
                        <MButton onClick={handleDeleteReportFilter} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Delete </MButton>
                      </Box>
                    </Box>
                  </Box>
                </Fade>
              </Modal>

              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className="modal-root"
                open={restrictOption}
                onClose={() => false}
                closeAfterTransition
              >
                <Fade in={restrictOption}>
                  <Box className="modal-paper modal-box modal-xs" id="transition-modal-title">
                    <Box className="modal-content-simple text-center" sx={{ p: '1rem !important' }}>
                      <ErrorOutlineSharpIcon color="primary" />
                      <Typography variant="subtitle1" className="text-plain font-weight-normal">To use Custom Reports Feature, Switch to Desktop screen</Typography>
                    </Box>
                  </Box>
                </Fade>
              </Modal>

              {
                (openCalculatedFields) ? <CalculatedFieldsV2
                  openPopup={openCalculatedFields}
                  setOpenPopup={setOpenCalculatedFields}
                  selectedDataset={reportDetails?.reportDetails?.dataSetId?._id}
                  closeCalcltdFldDialog={closeCalcltdFldDialog}
                  fetchMeasureList={fetchMeasureList}
                  reportDetails={reportDetails?.reportDetails}
                /> : null
              }
            </QuickFilterContextProvider>
          </ComparisonChartDetailsContextProvider>
        </ReportDetailsContextProvider>
      </MeasureListContextProvider>
      {

        exportProcessDialog ? <Dialog aria-labelledby="customized-dialog-title" open={exportProcessDialog}>
          <DialogTitle id="customized-dialog-title" >Export in Progress... </DialogTitle>
          <DialogContent dividers>
            <Typography > We're working to export the report... <CircularProgress /> </Typography>
          </DialogContent>
        </Dialog> : null
      }
    </RootStyle >
  )
}